const cities = [
  {
    city: "Aarhus",
    country: "Denmark",
    value: "AAR",
  },
  {
    city: "Abadan",
    country: "Iran",
    value: "ABD",
  },
  {
    city: "Abeche",
    country: "Chad",
    value: "AEH",
  },
  {
    city: "Aberdeen",
    country: "United Kingdom",
    value: "ABZ",
  },
  {
    city: "Aberdeen (SD)",
    country: "USA",
    value: "ABR",
  },
  {
    city: "Abidjan",
    country: "Cote d'Ivoire",
    value: "ABJ",
  },
  {
    city: "Abilene (TX)",
    country: "USA",
    value: "ABI",
  },
  {
    city: "Abu Dhabi - Abu Dhabi International",
    country: "United Arab Emirates",
    value: "AUH",
  },
  {
    city: "Abuja - Nnamdi Azikiwe International Airport",
    country: "Nigeria",
    value: "ABV",
  },
  {
    city: "Abu Rudeis",
    country: "Egypt",
    value: "AUE",
  },
  {
    city: "Abu Simbel",
    country: "Egypt",
    value: "ABS",
  },
  {
    city: "Acapulco",
    country: "Mexico",
    value: "ACA",
  },
  {
    city: "Accra - Kotoka International Airport",
    country: "Ghana",
    value: "ACC",
  },
  {
    city: "Adana",
    country: "Turkey",
    value: "ADA",
  },
  {
    city: "Addis Ababa - Bole International Airport",
    country: "Ethiopia",
    value: "ADD",
  },
  {
    city: "Adelaide",
    country: "Australia",
    value: "ADL",
  },
  {
    city: "Aden - Aden International Airport",
    country: "Yemen",
    value: "ADE",
  },
  {
    city: "Adiyaman",
    country: "Turkey",
    value: "ADF",
  },
  {
    city: "Adler/Sochi",
    country: "Russia",
    value: "AER",
  },
  {
    city: "Agades",
    country: "Niger",
    value: "AJY",
  },
  {
    city: "Agadir",
    country: "Morocco",
    value: "AGA",
  },
  {
    city: "Agana (Hagåtña)",
    country: "Guam",
    value: "SUM",
  },
  {
    city: "Aggeneys",
    country: "South Africa",
    value: "AGZ",
  },
  {
    city: "Aguadilla",
    country: "Puerto Rico",
    value: "BQN",
  },
  {
    city: "Aguascaliente",
    country: "Mexico",
    value: "AGU",
  },
  {
    city: "Ahmedabad",
    country: "India",
    value: "AMD",
  },
  {
    city: "Aiyura",
    country: "Papua New Guinea",
    value: "AYU",
  },
  {
    city: "Ajaccio",
    country: "France",
    value: "AJA",
  },
  {
    city: "Akita",
    country: "Japan",
    value: "AXT",
  },
  {
    city: "Akron (OH)",
    country: "USA",
    value: "CAK",
  },
  {
    city: "Akrotiri - RAF",
    country: "Cyprus",
    value: "AKT",
  },
  {
    city: "Al Ain",
    country: "United Arab Emirates",
    value: "AAN",
  },
  {
    city: "Al Arish",
    country: "Egypt",
    value: "AAC",
  },
  {
    city: "Albany",
    country: "Australia",
    value: "ALH",
  },
  {
    city: "Albany (GA)",
    country: "USA",
    value: "ABY",
  },
  {
    city: "Albany (NY) - Albany International Airport",
    country: "USA",
    value: "ALB",
  },
  {
    city: "Albi",
    country: "France",
    value: "LBI",
  },
  {
    city: "Alborg",
    country: "Denmark",
    value: "AAL",
  },
  {
    city: "Albuquerque (NM)",
    country: "USA",
    value: "ABQ",
  },
  {
    city: "Albury",
    country: "Australia",
    value: "ABX",
  },
  {
    city: "Alderney",
    country: "Channel Islands",
    value: "ACI",
  },
  {
    city: "Aleppo",
    country: "Syria",
    value: "ALP",
  },
  {
    city: "Alesund",
    country: "Norway",
    value: "AES",
  },
  {
    city: "Alexander Bay - Kortdoorn",
    country: "South Africa",
    value: "ALJ",
  },
  {
    city: "Alexandria - Borg el Arab Airport",
    country: "Egypt",
    value: "HBH",
  },
  {
    city: "Alexandria - El Nhouza Airport",
    country: "Egypt",
    value: "ALY",
  },
  {
    city: "Alexandria - Esler Field",
    country: "USA (LA)",
    value: "ESF",
  },
  {
    city: "Alfujairah (Fujairah)",
    country: "United Arab Emirates",
    value: "FJR",
  },
  {
    city: "Alghero Sassari",
    country: "Italy",
    value: "AHO",
  },
  {
    city: "Algiers, Houari Boumediene Airport",
    country: "Algeria",
    value: "ALG",
  },
  {
    city: "Al Hoceima",
    country: "Morocco",
    value: "AHU",
  },
  {
    city: "Alicante",
    country: "Spain",
    value: "ALC",
  },
  {
    city: "Alice Springs",
    country: "Australia",
    value: "ASP",
  },
  {
    city: "Alldays",
    country: "South Africa",
    value: "ADY",
  },
  {
    city: "Allentown (PA)",
    country: "USA",
    value: "ABE",
  },
  {
    city: "Almaty (Alma Ata) - Almaty International Airport",
    country: "Kazakhstan",
    value: "ALA",
  },
  {
    city: "Almeria",
    country: "Spain",
    value: "LEI",
  },
  {
    city: "Alta",
    country: "Norway",
    value: "ALF",
  },
  {
    city: "Altay",
    country: "PR China",
    value: "AAT",
  },
  {
    city: "Altenrhein",
    country: "Switzerland",
    value: "ACH",
  },
  {
    city: "Altoona (PA)",
    country: "USA",
    value: "AOO",
  },
  {
    city: "Altus",
    country: "USA",
    value: "AXS",
  },
  {
    city: "Amami",
    country: "Japan",
    value: "ASJ",
  },
  {
    city: "Amarillo (TX)",
    country: "USA",
    value: "AMA",
  },
  {
    city: "Amazon Bay",
    country: "Papua New Guinea",
    value: "AZB",
  },
  {
    city: "Amman - Queen Alia International Airport",
    country: "Jordan",
    value: "AMM",
  },
  {
    city: "Amman - Amman-Marka International Airport",
    country: "Jordan",
    value: "ADJ",
  },
  {
    city: "Amritsar",
    country: "India",
    value: "ATQ",
  },
  {
    city: "Amsterdam - Amsterdam Airport Schiphol",
    country: "Netherlands",
    value: "AMS",
  },
  {
    city: "Anand",
    country: "India",
    value: "QNB",
  },
  {
    city: "Anchorage (AK) - Ted Stevens Anchorage International",
    country: "USA",
    value: "ANC",
  },
  {
    city: "Ancona - Ancona Falconara Airport",
    country: "Italy",
    value: "AOI",
  },
  {
    city: "Andorra La Vella - Heliport",
    country: "Andorra",
    value: "ALV",
  },
  {
    city: "Anguilla",
    country: "Anguilla",
    value: "AXA",
  },
  {
    city: "Anjouan - Anjouan Airport",
    country: "Comoros (Comores)",
    value: "AJN",
  },
  {
    city: "Ankara",
    country: "Turkey",
    value: "ANK",
  },
  {
    city: "Ankara - Esenboğa International Airport",
    country: "Turkey",
    value: "ESB",
  },
  {
    city: "Annaba",
    country: "Algeria",
    value: "AAE",
  },
  {
    city: "Ann Arbor (MI)",
    country: "USA",
    value: "ARB",
  },
  {
    city: "Annecy",
    country: "France",
    value: "NCY",
  },
  {
    city: "Anniston (AL)",
    country: "USA",
    value: "ANB",
  },
  {
    city: "Antalya",
    country: "Turkey",
    value: "AYT",
  },
  {
    city: "Antananarivo (Tanannarive) - Ivato International Airport",
    country: "Madagascar",
    value: "TNR",
  },
  {
    city: "Antigua, V.C. Bird International",
    country: "Antigua and Barbuda",
    value: "ANU",
  },
  {
    city: "Antwerp",
    country: "Belgium",
    value: "ANR",
  },
  {
    city: "Aomori",
    country: "Japan",
    value: "AOJ",
  },
  {
    city: "Apia - Faleolo International Airport",
    country: "Samoa",
    value: "APW",
  },
  {
    city: "Appelton/Neenah/Menasha (WI)",
    country: "USA",
    value: "ATW",
  },
  {
    city: "Aqaba",
    country: "Jordan",
    value: "AQJ",
  },
  {
    city: "Aracaju",
    country: "Brazil",
    value: "AJU",
  },
  {
    city: "Arkhangelsk",
    country: "Russia",
    value: "ARH",
  },
  {
    city: "Arusha",
    country: "Tanzania",
    value: "ARK",
  },
  {
    city: "Araxos",
    country: "Greece",
    value: "GPA",
  },
  {
    city: "Arlit",
    country: "Niger",
    value: "RLT",
  },
  {
    city: "Arrecife/Lanzarote",
    country: "Spain",
    value: "ACE",
  },
  {
    city: "Aruba - Reina Beatrix International, Oranjestad",
    country: "Aruba",
    value: "AUA",
  },
  {
    city: "Asheville (NC)",
    country: "USA",
    value: "AVL",
  },
  {
    city: "Ashgabat - Saparmurat Turkmenbashy Int. Airport",
    country: "Turkmenistan",
    value: "ASB",
  },
  {
    city: "Asmara - Asmara International",
    country: "Eritrea",
    value: "ASM",
  },
  {
    city: "Aspen, (CO) - Aspen-Pitkin County Airport",
    country: "USA",
    value: "ASE",
  },
  {
    city: "Assiut",
    country: "Egypt",
    value: "ATZ",
  },
  {
    city: "Astana - Astana International Airport",
    country: "Kazakhstan",
    value: "TSE",
  },
  {
    city: "Asuncion - Asunción International Airport",
    country: "Paraguay",
    value: "ASU",
  },
  {
    city: "Aswan - Daraw Airport",
    country: "Egypt",
    value: "ASW",
  },
  {
    city: "Athens - Elefthérios Venizélos International Airport",
    country: "Greece",
    value: "ATH",
  },
  {
    city: "Athens, Hellinikon Airport",
    country: "Greece",
    value: "HEW",
  },
  {
    city: "Athens (GA)",
    country: "USA",
    value: "AHN",
  },
  {
    city: "Athens (OH)",
    country: "USA",
    value: "ATO",
  },
  {
    city: "Atlanta (GA) - Hartsfield Atlanta International Airport",
    country: "USA",
    value: "ATL",
  },
  {
    city: "Atlantic city (NJ) - Atlantic city International",
    country: "USA",
    value: "ACY",
  },
  {
    city: "Attawapiskat, NT",
    country: "Canada",
    value: "YAT",
  },
  {
    city: "Auckland - Auckland International Airport",
    country: "New Zealand",
    value: "AKL",
  },
  {
    city: "Augsburg - Augsbur gAirport",
    country: "Germany",
    value: "AGB",
  },
  {
    city: "Augusta (GA)",
    country: "USA",
    value: "AGS",
  },
  {
    city: "Augusta (ME) - Augusta State Airport",
    country: "USA",
    value: "AUG",
  },
  {
    city: "Aurillac",
    country: "France",
    value: "AUR",
  },
  {
    city: "Austin (TX) - Austin-Bergstrom Airport",
    country: "USA",
    value: "AUS",
  },
  {
    city: "Ayawasi",
    country: "Indonesia",
    value: "AYW",
  },
  {
    city: "Ayers Rock - Connellan",
    country: "Australia",
    value: "AYQ",
  },
  {
    city: "Ayr",
    country: "Australia",
    value: "AYR",
  },
  {
    city: "Badajoz",
    country: "Spain",
    value: "BJZ",
  },
  {
    city: "Bagdad - Baghdad International Airport",
    country: "Iraq",
    value: "BGW",
  },
  {
    city: "Bagdogra",
    country: "India",
    value: "IXB",
  },
  {
    city: "Bahamas - Lynden Pindling International Airport",
    country: "The Bahamas",
    value: "NAS",
  },
  {
    city: "Bahawalpur",
    country: "Pakistan",
    value: "BHV",
  },
  {
    city: "Bahrain - Bahrain International Airport",
    country: "Bahrain",
    value: "BAH",
  },
  {
    city: "Bakersfield (CA)",
    country: "USA",
    value: "BFL",
  },
  {
    city: "Baku - Heydar Aliyev International Airport",
    country: "Azerbaijan",
    value: "BAK",
  },
  {
    city: "Ballina",
    country: "Australia",
    value: "BNK",
  },
  {
    city: "Baltimore (MD) - Washington International Airport",
    country: "USA",
    value: "BWI",
  },
  {
    city: "Bamaga",
    country: "Australia",
    value: "ABM",
  },
  {
    city: "Bamako - Bamako-Sénou International Airport",
    country: "Mali",
    value: "BKO",
  },
  {
    city: "Bambari",
    country: "Central African Republic",
    value: "BBY",
  },
  {
    city: "Bandar Seri Begawan - Brunei International Airport",
    country: "Brunei",
    value: "BWN",
  },
  {
    city: "Bandung - Husein Sastranegara International Airport",
    country: "Indonesia",
    value: "BDO",
  },
  {
    city: "Bangalore",
    country: "India",
    value: "BLR",
  },
  {
    city: "Bangassou",
    country: "Central African Republic",
    value: "BGU",
  },
  {
    city: "Bangkok, Don Muang",
    country: "Thailand",
    value: "DMK",
  },
  {
    city: "Bangkok, Suvarnabhumi International",
    country: "Thailand",
    value: "BKK",
  },
  {
    city: "Bangor (ME)",
    country: "USA",
    value: "BGR",
  },
  {
    city: "Bangui - M'Poko International Airport",
    country: "Central African Republic",
    value: "BGF",
  },
  {
    city: "Banjul - Banjul International Airport (Yundum International)",
    country: "Gambia",
    value: "BJL",
  },
  {
    city: "Bannu",
    country: "Pakistan",
    value: "BNP",
  },
  {
    city: "Barcelona",
    country: "Spain",
    value: "BCN",
  },
  {
    city: "Barcelona",
    country: "Venezuela",
    value: "BLA",
  },
  {
    city: "Bardufoss",
    country: "Norway",
    value: "BDU",
  },
  {
    city: "Bari",
    country: "Italy",
    value: "BRI",
  },
  {
    city: "Barisal",
    country: "Bangladesh",
    value: "BZL",
  },
  {
    city: "Baroda",
    country: "India",
    value: "BDQ",
  },
  {
    city: "Barra (the famous tidal beach landing)",
    country: "United Kingdom",
    value: "BRR",
  },
  {
    city: "Barranquilla",
    country: "Colombia",
    value: "BAQ",
  },
  {
    city: "Basel",
    country: "Switzerland",
    value: "BSL",
  },
  {
    city: "Basel/Mulhouse",
    country: "Switzerland/France",
    value: "EAP",
  },
  {
    city: "Basra, Basrah",
    country: "Iraq",
    value: "BSR",
  },
  {
    city: "Basse-Terre - Pointe-à-Pitre International Airport",
    country: "Guadeloupe",
    value: "PTP",
  },
  {
    city: "Basseterre - Robert L. Bradshaw International Airport",
    country: "Saint Kitts and Nevis",
    value: "SKB",
  },
  {
    city: "Bastia",
    country: "France",
    value: "BIA",
  },
  {
    city: "Baton Rouge (LA) - Baton Rouge Metropolitan Airport",
    country: "USA",
    value: "BTR",
  },
  {
    city: "Bayreuth - Bindlacher-Berg",
    country: "Germany",
    value: "BYU",
  },
  {
    city: "Beaumont/Pt. Arthur (TX)",
    country: "USA",
    value: "BPT",
  },
  {
    city: "Beckley (WV)",
    country: "USA",
    value: "BKW",
  },
  {
    city: "Beef Island - Terrance B. Lettsome",
    country: "Virgin Islands (British)",
    value: "EIS",
  },
  {
    city: "Beijing",
    country: "China",
    value: "PEK",
  },
  {
    city: "Beijing - Nanyuan Airport",
    country: "China",
    value: "NAY",
  },
  {
    city: "Beira",
    country: "Mozambique",
    value: "BEW",
  },
  {
    city: "Beirut - Beirut Rafic Hariri International Airport",
    country: "Lebanon",
    value: "BEY",
  },
  {
    city: "Belem - Val de Cans International Airport",
    country: "Brazil",
    value: "BEL",
  },
  {
    city: "Belfast - George Best Belfast city Airport",
    country: "United Kingdom",
    value: "BHD",
  },
  {
    city: "Belfast - Belfast International Airport",
    country: "United Kingdom",
    value: "BFS",
  },
  {
    city: "Belgaum",
    country: "India",
    value: "IXG",
  },
  {
    city: "Belgrad (Beograd) - Belgrade Nikola Tesla International",
    country: "Serbia",
    value: "BEG",
  },
  {
    city: "Belize city - Philip S.W.Goldson International",
    country: "Belize",
    value: "BZE",
  },
  {
    city: "Bellingham (WA)",
    country: "USA",
    value: "BLI",
  },
  {
    city: "Belo Horizonte - Tancredo Neves International Airport",
    country: "Brazil",
    value: "CNF",
  },
  {
    city: "Bemidji (MN)",
    country: "USA",
    value: "BJI",
  },
  {
    city: "Benbecula",
    country: "United Kingdom",
    value: "BEB",
  },
  {
    city: "Benghazi (Bengasi)",
    country: "Libya",
    value: "BEN",
  },
  {
    city: "Benguela",
    country: "Angola",
    value: "BUG",
  },
  {
    city: "Benton Harbour (MI)",
    country: "USA",
    value: "BEH",
  },
  {
    city: "Berberati",
    country: "Central African Republic",
    value: "BBT",
  },
  {
    city: "Bergamo/Milan - Orio Al Serio",
    country: "Italy",
    value: "BGY",
  },
  {
    city: "Bergen",
    country: "Norway",
    value: "BGO",
  },
  {
    city: "Bergerac - Roumanieres",
    country: "France",
    value: "EGC",
  },
  {
    city: "Berlin",
    country: "Germany",
    value: "BER",
  },
  {
    city: "Berlin, Schoenefeld",
    country: "Germany",
    value: "SXF",
  },
  {
    city: "Berlin, Tegel",
    country: "Germany",
    value: "TXL",
  },
  {
    city: "Berlin, Tempelhof (ceased operating in 2008)",
    country: "Germany",
    value: "THF",
  },
  {
    city: "Bermuda - L.F. Wade International Airport",
    country: "Bermuda",
    value: "BDA",
  },
  {
    city: "Berne, Bern-Belp",
    country: "Switzerland",
    value: "BRN",
  },
  {
    city: "Berne, Railway Service",
    country: "Switzerland",
    value: "ZDJ",
  },
  {
    city: "Bethel (AK)",
    country: "USA",
    value: "BET",
  },
  {
    city: "Bhopal",
    country: "India",
    value: "BHO",
  },
  {
    city: "Bhubaneswar",
    country: "India",
    value: "BBI",
  },
  {
    city: "Biarritz",
    country: "France",
    value: "BIQ",
  },
  {
    city: "Bilbao",
    country: "Spain",
    value: "BIO",
  },
  {
    city: "Billings (MT)",
    country: "USA",
    value: "BIL",
  },
  {
    city: "Billund",
    country: "Denmark",
    value: "BLL",
  },
  {
    city: "Bintulu",
    country: "Malaysia",
    value: "BTU",
  },
  {
    city: "Biraro",
    country: "Central African Republic",
    value: "IRO",
  },
  {
    city: "Birmingham - Birmingham International Airport",
    country: "United Kingdom",
    value: "BHX",
  },
  {
    city: "Birmingham (AL)",
    country: "USA",
    value: "BHM",
  },
  {
    city: "Bishkek - Manas International Airport",
    country: "Kyrgyzstan",
    value: "FRU",
  },
  {
    city: "Bismarck (ND) - Bismarck Municipal Airport",
    country: "USA",
    value: "BIS",
  },
  {
    city: "Bissau - Osvaldo Vieiro International Airport",
    country: "Guinea-Bissau",
    value: "BXO",
  },
  {
    city: "Blackpool",
    country: "United Kingdom",
    value: "BLK",
  },
  {
    city: "Blackwater",
    country: "Australia",
    value: "BLT",
  },
  {
    city: "Blantyre (Mandala) - Chileka International Airport",
    country: "Malawi",
    value: "BLZ",
  },
  {
    city: "Blenheim",
    country: "New Zealand",
    value: "BHE",
  },
  {
    city: "Bloemfontein - Bloemfontein Airport",
    country: "South Africa",
    value: "BFN",
  },
  {
    city: "Bloomington (IL)",
    country: "USA",
    value: "BMI",
  },
  {
    city: "Bloomington (IN)",
    country: "USA",
    value: "BMG",
  },
  {
    city: "Bluefield (WV)",
    country: "USA",
    value: "BLF",
  },
  {
    city: "Boa Vista",
    country: "Brazil",
    value: "BVB",
  },
  {
    city: "Bobo/Dioulasso",
    country: "Burkina Faso",
    value: "BOY",
  },
  {
    city: "Bodo",
    country: "Norway",
    value: "BOO",
  },
  {
    city: "Bodrum - Milas Airport",
    country: "Turkey",
    value: "BJV",
  },
  {
    city: "Bogota - El Nuevo Dorado International Airport",
    country: "Colombia",
    value: "BOG",
  },
  {
    city: "Boise (ID) - Boise Air Terminal",
    country: "USA",
    value: "BOI",
  },
  {
    city: "Bologna",
    country: "Italy",
    value: "BLQ",
  },
  {
    city: "Bombay (Mumbai) - Chhatrapati Shivaji International",
    country: "India",
    value: "BOM",
  },
  {
    city: "Bonaire",
    country: "Netherlands Antilles",
    value: "BON",
  },
  {
    city: "Bonaventure, PQ",
    country: "Canada",
    value: "YVB",
  },
  {
    city: "Bora Bora",
    country: "French Polynesia",
    value: "BOB",
  },
  {
    city: "Bordeaux - Bordeaux Airport",
    country: "France",
    value: "BOD",
  },
  {
    city: "Borrego Springs (CA)",
    country: "USA",
    value: "BXS",
  },
  {
    city: "Boston (MA) - General Edward Lawrence Logan",
    country: "USA",
    value: "BOS",
  },
  {
    city: "Bouake",
    country: "Cote d'Ivoire",
    value: "BYK",
  },
  {
    city: "Bourgas/Burgas",
    country: "Bulgaria",
    value: "BOJ",
  },
  {
    city: "Bournemouth",
    country: "United Kingdom",
    value: "BOH",
  },
  {
    city: "Bowen",
    country: "Australia",
    value: "ZBO",
  },
  {
    city: "Bozeman (MT)",
    country: "USA",
    value: "BZN",
  },
  {
    city: "Bradford/Warren (PA) /Olean (NY)",
    country: "USA",
    value: "BFD",
  },
  {
    city: "Brainerd (MN)",
    country: "USA",
    value: "BRD",
  },
  {
    city: "Brampton Island",
    country: "Australia",
    value: "BMP",
  },
  {
    city: "Brasilia - President Juscelino Kubitschek International",
    country: "Brazil",
    value: "BSB",
  },
  {
    city: "Bratislava - M. R. Štefánik Airport",
    country: "Slovakia",
    value: "BTS",
  },
  {
    city: "Brazzaville - Maya-Maya Airport",
    country: "Congo (ROC)",
    value: "BZV",
  },
  {
    city: "Bremen - Bremen Airport (Flughafen Bremen)",
    country: "Germany",
    value: "BRE",
  },
  {
    city: "Brescia, Montichiari",
    country: "Italy",
    value: "VBS",
  },
  {
    city: "Brest",
    country: "France",
    value: "BES",
  },
  {
    city: "Bria",
    country: "Central African Republic",
    value: "BIV",
  },
  {
    city: "Bridgeport (CT)",
    country: "USA",
    value: "BDR",
  },
  {
    city: "Bridgetown - Grantley Adams International",
    country: "Barbados",
    value: "BGI",
  },
  {
    city: "Brindisi",
    country: "Italy",
    value: "BDS",
  },
  {
    city: "Brisbane",
    country: "Australia",
    value: "BNE",
  },
  {
    city: "Bristol",
    country: "United Kingdom",
    value: "BRS",
  },
  {
    city: "Broennoeysund",
    country: "Norway",
    value: "BNN",
  },
  {
    city: "Broken Hill",
    country: "Australia",
    value: "BHQ",
  },
  {
    city: "Brookings (SD)",
    country: "USA",
    value: "BKX",
  },
  {
    city: "Broome",
    country: "Australia",
    value: "BME",
  },
  {
    city: "Brunswick (GA)",
    country: "USA",
    value: "BQK",
  },
  {
    city: "Brussels - Brussels Airport",
    country: "Belgium",
    value: "BRU",
  },
  {
    city: "Bucaramanga",
    country: "Colombia",
    value: "BGA",
  },
  {
    city: "Bucharest",
    country: "Romania",
    value: "BUH",
  },
  {
    city: "Bucharest - Henri Coandă International Airport",
    country: "Romania",
    value: "OTP",
  },
  {
    city: "Budapest - Budapest Ferihegy International Airport",
    country: "Hungary",
    value: "BUD",
  },
  {
    city: "Buenos Aires",
    country: "Argentina",
    value: "BUE",
  },
  {
    city: "Buenos Aires, Ezeiza International Airport",
    country: "Argentina",
    value: "EZE",
  },
  {
    city: "Buenos Aires, Jorge Newbery",
    country: "Argentina",
    value: "AEP",
  },
  {
    city: "Buffalo Range",
    country: "Zimbabwe",
    value: "BFO",
  },
  {
    city: "Buffalo/Niagara Falls (NY)",
    country: "USA",
    value: "BUF",
  },
  {
    city: "Bujumbura - Bujumbura International Airport",
    country: "Burundi",
    value: "BJM",
  },
  {
    city: "Bulawayo",
    country: "Zimbabwe",
    value: "BUQ",
  },
  {
    city: "Bullhead city (NV)",
    country: "USA",
    value: "BHC",
  },
  {
    city: "Bundaberg",
    country: "Australia",
    value: "BDB",
  },
  {
    city: "Burbank (CA)",
    country: "USA",
    value: "BUR",
  },
  {
    city: "Burlington IA",
    country: "USA",
    value: "BRL",
  },
  {
    city: "Burlington (VT)",
    country: "USA",
    value: "BTV",
  },
  {
    city: "Burnie (Wynyard)",
    country: "Australia",
    value: "BWT",
  },
  {
    city: "Butte (MT)",
    country: "USA",
    value: "BTM",
  },
  {
    city: "Cabinda",
    country: "Angola",
    value: "CAB",
  },
  {
    city: "Cagliari",
    country: "Italy",
    value: "CAG",
  },
  {
    city: "Cairns",
    country: "Australia",
    value: "CNS",
  },
  {
    city: "Cairo - Cairo International Airport",
    country: "Egypt",
    value: "CAI",
  },
  {
    city: "Calama - El Loa",
    country: "Chile",
    value: "CJC",
  },
  {
    city: "Calcutta (Kolkata) - Netaji Subhas Chandra",
    country: "India",
    value: "CCU",
  },
  {
    city: "Calgary - Calgary International Airport",
    country: "Canada",
    value: "YYC",
  },
  {
    city: "Cali",
    country: "Colombia",
    value: "CLO",
  },
  {
    city: "Calicut",
    country: "India",
    value: "CCJ",
  },
  {
    city: "Calvi",
    country: "France",
    value: "CLY",
  },
  {
    city: "Cambridge Bay",
    country: "Canada",
    value: "YCB",
  },
  {
    city: "Cambrigde",
    country: "United Kingdom",
    value: "CBG",
  },
  {
    city: "Campbeltown",
    country: "United Kingdom",
    value: "CAL",
  },
  {
    city: "Campo Grande",
    country: "Brazil",
    value: "CGR",
  },
  {
    city: "Canberra - Canberra Airport",
    country: "Australia",
    value: "CBR",
  },
  {
    city: "Cancun",
    country: "Mexico",
    value: "CUN",
  },
  {
    city: "Cannes – Mandelieu Airport",
    country: "France",
    value: "CEQ",
  },
  {
    city: "Canouan (island) - Canouan Airport",
    country: "Saint Vincent & the Grenadines",
    value: "CIW",
  },
  {
    city: "Cape Town - Cape Town International Airport",
    country: "South Africa",
    value: "CPT",
  },
  {
    city: "Caracas - Simón Bolívar International Airport",
    country: "Venezuela",
    value: "CCS",
  },
  {
    city: "Cardiff - Cardiff Airport",
    country: "United Kingdom",
    value: "CWL",
  },
  {
    city: "Carlsbad (CA)",
    country: "USA",
    value: "CLD",
  },
  {
    city: "Carnarvon",
    country: "Australia",
    value: "CVQ",
  },
  {
    city: "Carnot",
    country: "Central African Republic",
    value: "CRF",
  },
  {
    city: "Carson city (NV)",
    country: "USA",
    value: "CSN",
  },
  {
    city: "Casablanca",
    country: "Morocco",
    value: "CAS",
  },
  {
    city: "Casablanca, Mohamed V",
    country: "Morocco",
    value: "CMN",
  },
  {
    city: "Casa de Campo - La Romana International Airport",
    country: "Dominican Republic",
    value: "LRM",
  },
  {
    city: "Casino",
    country: "Australia",
    value: "CSI",
  },
  {
    city: "Casper (WY)",
    country: "USA",
    value: "CPR",
  },
  {
    city: "Castaway",
    country: "Fiji",
    value: "CST",
  },
  {
    city: "Cartagena - Rafael Núñez International Airport",
    country: "Colombia",
    value: "CTG",
  },
  {
    city: "Castries - George F. L. Charles Airport",
    country: "Saint Lucia",
    value: "SLU",
  },
  {
    city: "Catania",
    country: "Italy",
    value: "CTA",
  },
  {
    city: "Cayenne - Cayenne-Rochambeau Airport",
    country: "French Guiana",
    value: "CAY",
  },
  {
    city: "Cottbus - Cottbus-Drewitz Airport",
    country: "Germany",
    value: "CBU",
  },
  {
    city: "Cebu city - Mactan-Cebu International",
    country: "Philippines",
    value: "CEB",
  },
  {
    city: "Cedar city (UT)",
    country: "USA",
    value: "CDC",
  },
  {
    city: "Cedar Rapids IA",
    country: "USA",
    value: "CID",
  },
  {
    city: "Ceduna",
    country: "Australia",
    value: "CED",
  },
  {
    city: "Cessnock",
    country: "Australia",
    value: "CES",
  },
  {
    city: "Chabarovsk (Khabarovsk)",
    country: "Russia",
    value: "KHV",
  },
  {
    city: "Chambery",
    country: "France",
    value: "CMF",
  },
  {
    city: "Champaign (IL)",
    country: "USA",
    value: "CMI",
  },
  {
    city: "Chandigarh - Chandigarh International Airport",
    country: "India",
    value: "IXC",
  },
  {
    city: "Changchun",
    country: "Jilin, PR China",
    value: "CGQ",
  },
  {
    city: "Chania",
    country: "Greece",
    value: "CHQ",
  },
  {
    city: "Chaoyang, Beijing - Chaoyang Airport",
    country: "PR China",
    value: "CHG",
  },
  {
    city: "Charleston (SC)",
    country: "USA",
    value: "CHS",
  },
  {
    city: "Charleston (WV) - Yeager Airport",
    country: "USA",
    value: "CRW",
  },
  {
    city: "Charlotte (NC)",
    country: "USA",
    value: "CLT",
  },
  {
    city: "Charlottesville (VA)",
    country: "USA",
    value: "CHO",
  },
  {
    city: "Charters Towers",
    country: "Australia",
    value: "CXT",
  },
  {
    city: "Chattanooga (TN)",
    country: "USA",
    value: "CHA",
  },
  {
    city: "Chengdu - Shuangliu",
    country: "Sichuan, PR China",
    value: "CTU",
  },
  {
    city: "Chennai (Madras)",
    country: "India",
    value: "MAA",
  },
  {
    city: "Cheyenne (WY) - Cheyenne Regional Airport",
    country: "USA",
    value: "CYS",
  },
  {
    city: "Chiang Mai - Chiang Mai International Airport",
    country: "Thailand",
    value: "CNX",
  },
  {
    city: "Chiba city",
    country: "Japan",
    value: "QCB",
  },
  {
    city: "Chicago (IL), Midway",
    country: "USA",
    value: "MDW",
  },
  {
    city: "Chicago (IL), O'Hare International Airport",
    country: "USA",
    value: "ORD",
  },
  {
    city: "Chicago (IL)",
    country: "USA",
    value: "CHI",
  },
  {
    city: "Chichen Itza",
    country: "Mexico",
    value: "CZA",
  },
  {
    city: "Chico (CA)",
    country: "USA",
    value: "CIC",
  },
  {
    city: "Chihuahua - Gen Fierro Villalobos",
    country: "Mexico",
    value: "CUU",
  },
  {
    city: "Chios",
    country: "Greece",
    value: "JKH",
  },
  {
    city: "Chipata",
    country: "Zambia",
    value: "CIP",
  },
  {
    city: "Chisinau - Chişinău International Airport",
    country: "Moldova",
    value: "KIV",
  },
  {
    city: "Chita (Tschita)",
    country: "Russia",
    value: "HTA",
  },
  {
    city: "Sapporo - New Chitose Airport",
    country: "Japan",
    value: "CTS",
  },
  {
    city: "Chitral",
    country: "Pakistan",
    value: "CJL",
  },
  {
    city: "Chittagong",
    country: "Bangladesh",
    value: "CGP",
  },
  {
    city: "Chongqing - Jiangbei International Airport",
    country: "Sichuan, PR China",
    value: "CKG",
  },
  {
    city: "Christchurch",
    country: "New Zealand",
    value: "CHC",
  },
  {
    city: "Chub Cay",
    country: "Bahamas",
    value: "CCZ",
  },
  {
    city: "Churchill",
    country: "Canada",
    value: "YYQ",
  },
  {
    city: "Cienfuegos - Jaime González Airport",
    country: "Cuba",
    value: "CFG",
  },
  {
    city: "Cincinnati (OH) - Cincinnati/Northern Kentucky Int'l",
    country: "USA",
    value: "CVG",
  },
  {
    city: "Ciudad Del Carmen",
    country: "Mexico",
    value: "CME",
  },
  {
    city: "Ciudad Guayana",
    country: "Venezuela",
    value: "CGU",
  },
  {
    city: "Ciudad Juarez",
    country: "Mexico",
    value: "CJS",
  },
  {
    city: "Ciudad Obregon",
    country: "Mexico",
    value: "CEN",
  },
  {
    city: "Ciudad Victoria",
    country: "Mexico",
    value: "CVM",
  },
  {
    city: "Clarksburg (WV)",
    country: "USA",
    value: "CKB",
  },
  {
    city: "Clermont",
    country: "Australia",
    value: "CMQ",
  },
  {
    city: "Clermont Ferrand",
    country: "France",
    value: "CFE",
  },
  {
    city: "Cleveland (OH) , Burke Lakefront",
    country: "USA",
    value: "BKL",
  },
  {
    city: "Cleveland (OH) - Cleveland Hopkins International",
    country: "USA",
    value: "CLE",
  },
  {
    city: "Cochabamba",
    country: "Bolivia",
    value: "CBB",
  },
  {
    city: "Cochin",
    country: "India",
    value: "COK",
  },
  {
    city: "Cody/Powell/Yellowstone (WY)",
    country: "USA",
    value: "COD",
  },
  {
    city: "Coffmann Cove (AK)",
    country: "USA",
    value: "KCC",
  },
  {
    city: "Coffs Harbour",
    country: "Australia",
    value: "CFS",
  },
  {
    city: "Coimbatore",
    country: "India",
    value: "CJB",
  },
  {
    city: "Colima",
    country: "Mexico",
    value: "CLQ",
  },
  {
    city: "College Station/Bryan (TX)",
    country: "USA",
    value: "CLL",
  },
  {
    city: "Collinsville",
    country: "Australia",
    value: "KCE",
  },
  {
    city: "Cologne - Cologne Airport (Flughafen Köln/Bonn)",
    country: "Germany",
    value: "CGN",
  },
  {
    city: "Colombo - Bandaranaike International Airport",
    country: "Sri Lanka",
    value: "CMB",
  },
  {
    city: "Colorado Springs (CO)",
    country: "USA",
    value: "COS",
  },
  {
    city: "Columbia (SC) - Columbia Metropolitan Airport",
    country: "USA",
    value: "CAE",
  },
  {
    city: "Columbus (GA)",
    country: "USA",
    value: "CSG",
  },
  {
    city: "Columbus (OH) - Port Columbus International",
    country: "USA",
    value: "CMH",
  },
  {
    city: "Conakry - Conakry International Airport",
    country: "Guinea",
    value: "CKY",
  },
  {
    city: "Concord (CA) - Buchanan Field",
    country: "USA",
    value: "CCR",
  },
  {
    city: "Concord (NH) - Concord Municipal Airport",
    country: "USA",
    value: "CON",
  },
  {
    city: "Constantine",
    country: "Algeria",
    value: "CZL",
  },
  {
    city: "Constanta (Constanța) - Constanta Int'l Airport",
    country: "Romania",
    value: "CND",
  },
  {
    city: "Coober Pedy",
    country: "Australia",
    value: "CPD",
  },
  {
    city: "Cooktown",
    country: "Australia",
    value: "CTN",
  },
  {
    city: "Cooma",
    country: "Australia",
    value: "OOM",
  },
  {
    city: "Copenhagen - Copenhagen Airport",
    country: "Denmark",
    value: "CPH",
  },
  {
    city: "Cordoba",
    country: "Argentina",
    value: "COR",
  },
  {
    city: "Cordoba",
    country: "Spain",
    value: "ODB",
  },
  {
    city: "Cordova (AK)",
    country: "USA",
    value: "CDV",
  },
  {
    city: "Corfu",
    country: "Greece",
    value: "CFU",
  },
  {
    city: "Cork",
    country: "Ireland",
    value: "ORK",
  },
  {
    city: "Corpus Christi (TX)",
    country: "USA",
    value: "CRP",
  },
  {
    city: "Cotonou - Cotonou Cadjehoun Airport",
    country: "Benin",
    value: "COO",
  },
  {
    city: "Coventry - Baginton",
    country: "United Kingdom",
    value: "CVT",
  },
  {
    city: "Cozmel",
    country: "Mexico",
    value: "CZM",
  },
  {
    city: "Craig (AK)",
    country: "USA",
    value: "CGA",
  },
  {
    city: "Crescent city (CA)",
    country: "USA",
    value: "CEC",
  },
  {
    city: "Cuiaba - Marechal Rondon International Airport",
    country: "Brazil",
    value: "CGB",
  },
  {
    city: "Culiacan",
    country: "Mexico",
    value: "CUL",
  },
  {
    city: "Curacao - Curaçao International Airport",
    country: "Netherlands Antilles",
    value: "CUR",
  },
  {
    city: "Curitiba - Afonso Pena International Airport",
    country: "Brazil",
    value: "CWB",
  },
  {
    city: "Cuyo",
    country: "Philippines",
    value: "CYU",
  },
  {
    city: "Dakar - Léopold Sédar Senghor International Airport",
    country: "Senegal",
    value: "DKR",
  },
  {
    city: "Dalaman",
    country: "Turkey",
    value: "DLM",
  },
  {
    city: "Dalby",
    country: "Australia",
    value: "DBY",
  },
  {
    city: "Dalian - Zhoushuizi International Airport",
    country: "Liaoning, PR China",
    value: "DLC",
  },
  {
    city: "Dallas (TX) , Love Field",
    country: "USA",
    value: "DAL",
  },
  {
    city: "Dallas/Ft. Worth (TX) - Dallas/Fort Worth International",
    country: "USA",
    value: "DFW",
  },
  {
    city: "Daloa",
    country: "Cote d'Ivoire",
    value: "DJO",
  },
  {
    city: "Damascus, International",
    country: "Syria",
    value: "DAM",
  },
  {
    city: "Dammam, King Fahad International",
    country: "Saudi Arabien",
    value: "DMM",
  },
  {
    city: "Danville (VA)",
    country: "USA",
    value: "DAN",
  },
  {
    city: "Dar es Salam (Daressalam) - Julius Nyerere Int'l",
    country: "Tanzania",
    value: "DAR",
  },
  {
    city: "Darwin",
    country: "Australia",
    value: "DRW",
  },
  {
    city: "Daydream Island",
    country: "Australia",
    value: "DDI",
  },
  {
    city: "Dayton (OH)",
    country: "USA",
    value: "DAY",
  },
  {
    city: "Daytona Beach (FL)",
    country: "USA",
    value: "DAB",
  },
  {
    city: "Decatur (IL)",
    country: "USA",
    value: "DEC",
  },
  {
    city: "Deer Lake/Corner Brook",
    country: "Canada",
    value: "YDF",
  },
  {
    city: "Delhi - Indira Gandhi International Airport",
    country: "India",
    value: "DEL",
  },
  {
    city: "Den Haag (The Hague)",
    country: "Netherlands",
    value: "HAG",
  },
  {
    city: "Denizli",
    country: "Turkey",
    value: "DNZ",
  },
  {
    city: "Denpasar/Bali",
    country: "Indonesia",
    value: "DPS",
  },
  {
    city: "Denver (CO) - Denver International Airport",
    country: "USA",
    value: "DEN",
  },
  {
    city: "Dera Ismail Khan - Dera Ismail Khan Airport",
    country: "Pakistan",
    value: "DSK",
  },
  {
    city: "Derby",
    country: "Australia",
    value: "DRB",
  },
  {
    city: "Derry (Londonderry)",
    country: "United Kingdom",
    value: "LDY",
  },
  {
    city: "Des Moines (IA) - Des Moines International Airport",
    country: "USA",
    value: "DSM",
  },
  {
    city: "Detroit (MI) , Coleman A. Young Municipal",
    country: "USA",
    value: "DET",
  },
  {
    city: "Detroit (MI) , Wayne County Airport",
    country: "USA",
    value: "DTW",
  },
  {
    city: "Detroit (MI) , Metropolitan Area",
    country: "USA",
    value: "DTT",
  },
  {
    city: "Devils Lake (ND)",
    country: "USA",
    value: "DVL",
  },
  {
    city: "Devonport",
    country: "Australia",
    value: "DPO",
  },
  {
    city: "Dhahran",
    country: "Saudi Arabia",
    value: "DHA",
  },
  {
    city: "Dhaka - Zia International Airport",
    country: "Bangladesh",
    value: "DAC",
  },
  {
    city: "Dili - Nicolau Lobato International Airport",
    country: "Timor Leste (East Timor)",
    value: "DIL",
  },
  {
    city: "Dillingham (AK)",
    country: "USA",
    value: "DLG",
  },
  {
    city: "Dinard",
    country: "France",
    value: "DNR",
  },
  {
    city: "Disneyland Paris",
    country: "France",
    value: "DLP",
  },
  {
    city: "Djerba",
    country: "Tunisia",
    value: "DJE",
  },
  {
    city: "Djibouti (city) - Djibouti-Ambouli International Airport",
    country: "Djibouti",
    value: "JIB",
  },
  {
    city: "Dodoma - Dodoma Airport",
    country: "Tanzania",
    value: "DOD",
  },
  {
    city: "Doha - Doha International Airport",
    country: "Qatar",
    value: "DOH",
  },
  {
    city: "Doncaster/Sheffield, Robin Hood International Airport",
    country: "United Kingdom",
    value: "DSA",
  },
  {
    city: "Donegal (Carrickfin)",
    country: "Ireland",
    value: "CFN",
  },
  {
    city: "Dortmund",
    country: "Germany",
    value: "DTM",
  },
  {
    city: "Dothan (AL)",
    country: "USA",
    value: "DHN",
  },
  {
    city: "Douala",
    country: "Cameroon",
    value: "DLA",
  },
  {
    city: "Dresden - Dresden Airport",
    country: "Germany",
    value: "DRS",
  },
  {
    city: "Dubai - Dubai International Airport",
    country: "United Arab Emirates",
    value: "DXB",
  },
  {
    city: "Dubbo",
    country: "Australia",
    value: "DBO",
  },
  {
    city: "Dublin - Dublin International Airport",
    country: "Ireland",
    value: "DUB",
  },
  {
    city: "Dubois (PA)",
    country: "USA",
    value: "DUJ",
  },
  {
    city: "Dubrovnik",
    country: "Croatia (Hrvatska)",
    value: "DBV",
  },
  {
    city: "Dubuque IA",
    country: "USA",
    value: "DBQ",
  },
  {
    city: "Duesseldorf - Düsseldorf International Airport",
    country: "Germany",
    value: "DUS",
  },
  {
    city: "Duluth (MN) /Superior (WI)",
    country: "USA",
    value: "DLH",
  },
  {
    city: "Dundee",
    country: "United Kingdom",
    value: "DND",
  },
  {
    city: "Dunedin",
    country: "New Zealand",
    value: "DUD",
  },
  {
    city: "Dunk Island",
    country: "Australia",
    value: "DKI",
  },
  {
    city: "Durango (CO)",
    country: "USA",
    value: "DRO",
  },
  {
    city: "Durban",
    country: "South Africa",
    value: "DUR",
  },
  {
    city: "Dushanbe (Duschanbe) - Dushanbe Airport",
    country: "Tajikistan",
    value: "DYU",
  },
  {
    city: "Dutch Harbor (AK)",
    country: "USA",
    value: "DUT",
  },
  {
    city: "Dysart",
    country: "Australia",
    value: "DYA",
  },
  {
    city: "Dzaoudzi",
    country: "Mayotte",
    value: "DZA",
  },
  {
    city: "East London",
    country: "South Africa",
    value: "ELS",
  },
  {
    city: "Easter Island",
    country: "Chile",
    value: "IPC",
  },
  {
    city: "Eau Clarie (WI)",
    country: "USA",
    value: "EAU",
  },
  {
    city: "Edinburgh - Edinburgh Airport",
    country: "Scotland, UK",
    value: "EDI",
  },
  {
    city: "Edmonton",
    country: "Canada",
    value: "YEA",
  },
  {
    city: "Edmonton, International",
    country: "Canada",
    value: "YEG",
  },
  {
    city: "Edmonton, Municipal",
    country: "Canada",
    value: "YXD",
  },
  {
    city: "Egilsstadir",
    country: "Iceland",
    value: "EGS",
  },
  {
    city: "Eindhoven",
    country: "Netherlands",
    value: "EIN",
  },
  {
    city: "Samana - Samaná El Catey International Airport",
    country: "Dominican Republic",
    value: "AZS",
  },
  {
    city: "Elba Island, Marina Di Campo",
    country: "Italy",
    value: "EBA",
  },
  {
    city: "Elat",
    country: "Israel",
    value: "ETH",
  },
  {
    city: "Elat, Ovula",
    country: "Israel",
    value: "VDA",
  },
  {
    city: "Elkhart (IN)",
    country: "USA",
    value: "EKI",
  },
  {
    city: "Elko (NV)",
    country: "USA",
    value: "EKO",
  },
  {
    city: "Ellisras",
    country: "South Africa",
    value: "ELL",
  },
  {
    city: "El Minya",
    country: "Egypt",
    value: "EMY",
  },
  {
    city: "Elmira (NY)",
    country: "USA",
    value: "ELM",
  },
  {
    city: "El Paso (TX) - El Paso International Airport",
    country: "USA",
    value: "ELP",
  },
  {
    city: "Ely (NV)",
    country: "USA",
    value: "ELY",
  },
  {
    city: "Emerald",
    country: "Australia",
    value: "EDR",
  },
  {
    city: "Emerald",
    country: "Australia",
    value: "EMD",
  },
  {
    city: "Enontekioe",
    country: "Finland",
    value: "ENF",
  },
  {
    city: "Entebbe - Entebbe International Airport",
    country: "Uganda",
    value: "EBB",
  },
  {
    city: "Erfurt - Erfurt Airport (Flughafen Erfurt)",
    country: "Germany",
    value: "ERF",
  },
  {
    city: "Erie (PA)",
    country: "USA",
    value: "ERI",
  },
  {
    city: "Eriwan (Yerevan, Jerevan)",
    country: "Armenia",
    value: "EVN",
  },
  {
    city: "Erzincan",
    country: "Turkey",
    value: "ERC",
  },
  {
    city: "Erzurum",
    country: "Turkey",
    value: "ERZ",
  },
  {
    city: "Esbjerg",
    country: "Denmark",
    value: "EBJ",
  },
  {
    city: "Escanaba (MI)",
    country: "USA",
    value: "ESC",
  },
  {
    city: "Esperance",
    country: "Australia",
    value: "EPR",
  },
  {
    city: "Eugene (OR)",
    country: "USA",
    value: "EUG",
  },
  {
    city: "Eureka (CA)",
    country: "USA",
    value: "ACV",
  },
  {
    city: "Evansville (IN)",
    country: "USA",
    value: "EVV",
  },
  {
    city: "Evenes",
    country: "Norway",
    value: "EVE",
  },
  {
    city: "Exeter",
    country: "United Kingdom",
    value: "EXT",
  },
  {
    city: "Fairbanks (AK)",
    country: "USA",
    value: "FAI",
  },
  {
    city: "Fair Isle (Shetland)",
    country: "United Kingdom",
    value: "FIE",
  },
  {
    city: "Faisalabad",
    country: "Pakistan",
    value: "LYP",
  },
  {
    city: "Fargo (ND) (MN)",
    country: "USA",
    value: "FAR",
  },
  {
    city: "Farmington (NM)",
    country: "USA",
    value: "FMN",
  },
  {
    city: "Faro",
    country: "Portugal",
    value: "FAO",
  },
  {
    city: "Faroer - Vágar Airport",
    country: "Denmark",
    value: "FAE",
  },
  {
    city: "Fayetteville (AR)",
    country: "USA",
    value: "FYV",
  },
  {
    city: "Fayetteville/Ft. Bragg (NC)",
    country: "USA",
    value: "FAY",
  },
  {
    city: "Fes",
    country: "Morocco",
    value: "FEZ",
  },
  {
    city: "Figari",
    country: "France",
    value: "FSC",
  },
  {
    city: "Flagstaff (AZ)",
    country: "USA",
    value: "FLG",
  },
  {
    city: "Flin Flon",
    country: "Canada",
    value: "YFO",
  },
  {
    city: "Flint (MI)",
    country: "USA",
    value: "FNT",
  },
  {
    city: "Florence (Firenze) - Peretola Airport",
    country: "Italy",
    value: "FLR",
  },
  {
    city: "Florence (SC)",
    country: "USA",
    value: "FLO",
  },
  {
    city: "Florianopolis",
    country: "Brazil",
    value: "FLN",
  },
  {
    city: "Floro",
    country: "Norway",
    value: "FRO",
  },
  {
    city: "Fort Albert",
    country: "Canada",
    value: "YFA",
  },
  {
    city: "Fortaleza - Pinto Martins Airport",
    country: "Brazil",
    value: "FOR",
  },
  {
    city: "Fort de France - Martinique Aimé Césaire International",
    country: "Martinique",
    value: "FDF",
  },
  {
    city: "Fort Dodge IA",
    country: "USA",
    value: "FOD",
  },
  {
    city: "Fort Huachuca/Sierra Vista (AZ)",
    country: "USA",
    value: "FHU",
  },
  {
    city: "Fort Lauderdale/Hollywood (FL)",
    country: "USA",
    value: "FLL",
  },
  {
    city: "Fort McMurray",
    country: "Canada",
    value: "YMM",
  },
  {
    city: "Fort Myers, Metropolitan Area (FL)",
    country: "USA",
    value: "FMY",
  },
  {
    city: "Fort Myers, Southwest Florida Reg (FL)",
    country: "USA",
    value: "RSW",
  },
  {
    city: "Fort Riley (KS) - Marshall AAF",
    country: "USA",
    value: "FRI",
  },
  {
    city: "Fort Smith",
    country: "Canada",
    value: "YSM",
  },
  {
    city: "Fort Smith (AR)",
    country: "USA",
    value: "FSM",
  },
  {
    city: "Fort St. John",
    country: "Canada",
    value: "YXJ",
  },
  {
    city: "Fort Walton Beach (FL)",
    country: "USA",
    value: "VPS",
  },
  {
    city: "Fort Wayne (IN)",
    country: "USA",
    value: "FWA",
  },
  {
    city: "Fort Worth (TX) - Dallas/Fort Worth International Airport",
    country: "USA",
    value: "DFW",
  },
  {
    city: "Foula (Shetland)",
    country: "United Kingdom",
    value: "FOU",
  },
  {
    city: "Francistown",
    country: "Botswana",
    value: "FRW",
  },
  {
    city: "Frankfurt/Main - Frankfurt Airport (Rhein-Main-Flughafen)",
    country: "Germany",
    value: "FRA",
  },
  {
    city: "Frankfurt/Hahn",
    country: "Germany",
    value: "HHN",
  },
  {
    city: "Franklin/Oil city (PA)",
    country: "USA",
    value: "FKL",
  },
  {
    city: "Fredericton",
    country: "Canada",
    value: "YFC",
  },
  {
    city: "Freeport - Grand Bahama International Airport",
    country: "Bahamas",
    value: "FPO",
  },
  {
    city: "Freetown - Freetown-Lungi International Airport",
    country: "Sierra Leone",
    value: "FNA",
  },
  {
    city: "Frejus",
    country: "France",
    value: "FRJ",
  },
  {
    city: "Fresno (CA)",
    country: "USA",
    value: "FAT",
  },
  {
    city: "Friedrichshafen - Bodensee-Airport Friedrichshafen",
    country: "Germany",
    value: "FDH",
  },
  {
    city: "Fuerteventura",
    country: "Spain",
    value: "FUE",
  },
  {
    city: "Fujairah, International Airport",
    country: "United Arab Emirates",
    value: "FJR",
  },
  {
    city: "Fukuoka",
    country: "Japan",
    value: "FUK",
  },
  {
    city: "Fukushima - Fukushima Airport",
    country: "Japan",
    value: "FKS",
  },
  {
    city: "Funchal",
    country: "Portugal",
    value: "FNC",
  },
  {
    city: "Futuna",
    country: "Wallis and Futuna Islands",
    value: "FUT",
  },
  {
    city: "Gaborone - Sir Seretse Khama International Airport",
    country: "Botswana",
    value: "GBE",
  },
  {
    city: "Gadsden (AL)",
    country: "USA",
    value: "GAD",
  },
  {
    city: "Gainesville (FL)",
    country: "USA",
    value: "GNV",
  },
  {
    city: "Galway",
    country: "Ireland",
    value: "GWY",
  },
  {
    city: "Gander",
    country: "Canada",
    value: "YQX",
  },
  {
    city: "Garoua",
    country: "Cameroon",
    value: "GOU",
  },
  {
    city: "Gaza city - Gaza International Airport",
    country: "Palestinian Territory",
    value: "GZA",
  },
  {
    city: "Gaziantep",
    country: "Turkey",
    value: "GZT",
  },
  {
    city: "Gdansk",
    country: "Poland",
    value: "GDN",
  },
  {
    city: "Geelong",
    country: "Australia",
    value: "GEX",
  },
  {
    city: "Geneva - Geneva-Cointrin International Airport",
    country: "Switzerland",
    value: "GVA",
  },
  {
    city: "Genoa",
    country: "Italy",
    value: "GOA",
  },
  {
    city: "George",
    country: "South Africa",
    value: "GRJ",
  },
  {
    city: "Georgetown - Cheddi Jagan International Airport",
    country: "Guyana",
    value: "GEO",
  },
  {
    city: "Geraldton",
    country: "Australia",
    value: "GET",
  },
  {
    city: "Gerona",
    country: "Spain",
    value: "GRO",
  },
  {
    city: "Ghent (Gent)",
    country: "Belgium",
    value: "GNE",
  },
  {
    city: "Gibraltar",
    country: "Gibraltar",
    value: "GIB",
  },
  {
    city: "Gilette (WY)",
    country: "USA",
    value: "GCC",
  },
  {
    city: "Gilgit",
    country: "Pakistan",
    value: "GIL",
  },
  {
    city: "Gillam",
    country: "Canada",
    value: "YGX",
  },
  {
    city: "Gladstone",
    country: "Australia",
    value: "GLT",
  },
  {
    city: "Glasgow, Prestwick",
    country: "United Kingdom",
    value: "PIK",
  },
  {
    city: "Glasgow",
    country: "United Kingdom",
    value: "GLA",
  },
  {
    city: "Glasgow (MT)",
    country: "USA",
    value: "GGW",
  },
  {
    city: "Glendive (MT)",
    country: "USA",
    value: "GDV",
  },
  {
    city: "Goa",
    country: "India",
    value: "GOI",
  },
  {
    city: "Goiania, Santa Genoveva Airport",
    country: "Brazil",
    value: "GYN",
  },
  {
    city: "Gold Coast",
    country: "Australia",
    value: "OOL",
  },
  {
    city: "Goondiwindi",
    country: "Australia",
    value: "GOO",
  },
  {
    city: "Goose Bay",
    country: "Canada",
    value: "YYR",
  },
  {
    city: "Gorna",
    country: "Bulgaria",
    value: "GOZ",
  },
  {
    city: "Gothenburg (Göteborg) - Landvetter",
    country: "Sweden",
    value: "GOT",
  },
  {
    city: "Gove (Nhulunbuy)",
    country: "Australia",
    value: "GOV",
  },
  {
    city: "Govenors Harbour",
    country: "Bahamas",
    value: "GHB",
  },
  {
    city: "Granada",
    country: "Spain",
    value: "GRX",
  },
  {
    city: "Grand Bahama International",
    country: "Bahamas",
    value: "FPO",
  },
  {
    city: "Grand Canyon (AZ)",
    country: "USA",
    value: "GCN",
  },
  {
    city: "Grand Cayman - Owen Roberts International",
    country: "Cayman Islands",
    value: "GCM",
  },
  {
    city: "Grand Forks (ND)",
    country: "USA",
    value: "GFK",
  },
  {
    city: "Grand Junction (CO)",
    country: "USA",
    value: "GJT",
  },
  {
    city: "Grand Rapids (MI)",
    country: "USA",
    value: "GRR",
  },
  {
    city: "Grand Rapids (MN)",
    country: "USA",
    value: "GPZ",
  },
  {
    city: "Graz",
    country: "Austria",
    value: "GRZ",
  },
  {
    city: "Great Falls (MT)",
    country: "USA",
    value: "GTF",
  },
  {
    city: "Great Keppel Island",
    country: "Australia",
    value: "GKL",
  },
  {
    city: "Green Bay (WI)",
    country: "USA",
    value: "GRB",
  },
  {
    city: "Greenbrier/Lewisburg (WV)",
    country: "USA",
    value: "LWB",
  },
  {
    city: "Greensboro/Winston Salem (NC)",
    country: "USA",
    value: "GSO",
  },
  {
    city: "Greenville (MS)",
    country: "USA",
    value: "GLH",
  },
  {
    city: "Greenville (NC)",
    country: "USA",
    value: "PGV",
  },
  {
    city: "Greenville/Spartanburg (SC)",
    country: "USA",
    value: "GSP",
  },
  {
    city: "Grenada - Point Salines Airport also Maurice Bishop",
    country: "Grenada",
    value: "GND",
  },
  {
    city: "Grenoble",
    country: "France",
    value: "GNB",
  },
  {
    city: "Griffith",
    country: "Australia",
    value: "GFF",
  },
  {
    city: "Groningen - Eelde",
    country: "Netherlands",
    value: "GRQ",
  },
  {
    city: "Groote Eylandt - Alyangula",
    country: "Australia",
    value: "GTE",
  },
  {
    city: "Groton/New London (CT)",
    country: "USA",
    value: "GON",
  },
  {
    city: "Guadalajara",
    country: "Mexico",
    value: "GDL",
  },
  {
    city: "Guadalcanal",
    country: "Solomon Islands",
    value: "GSI",
  },
  {
    city: "Guam",
    country: "Guam",
    value: "GUM",
  },
  {
    city: "Guangzhou (Canton) - Baiyun International Airport",
    country: "Guangdong, PR China",
    value: "CAN",
  },
  {
    city: "Sao Paulo - Guarulhos International",
    country: "Brazil",
    value: "GRU",
  },
  {
    city: "Guatemala city - La Aurora International Airport",
    country: "Guatemala",
    value: "GUA",
  },
  {
    city: "Guayaquil - Simon Bolivar",
    country: "Ecuador",
    value: "GYE",
  },
  {
    city: "Guernsey",
    country: "Channel Islands",
    value: "GCI",
  },
  {
    city: "Guettin",
    country: "Germany",
    value: "GTI",
  },
  {
    city: "Gulfport/Biloxi (MS)",
    country: "USA",
    value: "GPT",
  },
  {
    city: "Guilin - Liangjiang",
    country: "Guangxi, PR China",
    value: "KWL",
  },
  {
    city: "Gulu",
    country: "Uganda",
    value: "ULU",
  },
  {
    city: "Gunnison/Crested Butte (CO)",
    country: "USA",
    value: "GUC",
  },
  {
    city: "Guwahati",
    country: "India",
    value: "GAU",
  },
  {
    city: "Gwadar",
    country: "Pakistan",
    value: "GWD",
  },
  {
    city: "Gweru",
    country: "Zimbabwe",
    value: "GWE",
  },
  {
    city: "Gympie",
    country: "Australia",
    value: "GYP",
  },
  {
    city: "Hachijo Jima",
    country: "Japan",
    value: "HAC",
  },
  {
    city: "Hagåtña - Guam International Airport",
    country: "Guam",
    value: "GUM",
  },
  {
    city: "Haifa",
    country: "Israel",
    value: "HFA",
  },
  {
    city: "Haines (AK)",
    country: "USA",
    value: "HNS",
  },
  {
    city: "Hakodate",
    country: "Japan",
    value: "HKD",
  },
  {
    city: "Halifax International",
    country: "Canada",
    value: "YHZ",
  },
  {
    city: "Hall Beach",
    country: "Canada",
    value: "YUX",
  },
  {
    city: "Hamburg - Fuhlsbuettel",
    country: "Germany",
    value: "HAM",
  },
  {
    city: "Hamilton",
    country: "Australia",
    value: "HLT",
  },
  {
    city: "Hamilton",
    country: "Canada",
    value: "YHM",
  },
  {
    city: "Hamilton",
    country: "New Zealand",
    value: "HLZ",
  },
  {
    city: "Hamilton Island",
    country: "Australia",
    value: "HTI",
  },
  {
    city: "Hammerfest",
    country: "Norway",
    value: "HFT",
  },
  {
    city: "Hancock (MI)",
    country: "USA",
    value: "CMX",
  },
  {
    city: "Hangchow (Hangzhou)",
    country: "Zhejiang, PR China",
    value: "HGH",
  },
  {
    city: "Hannover",
    country: "Germany",
    value: "HAJ",
  },
  {
    city: "Hanoi - Noi Bai International Airport",
    country: "Vietnam",
    value: "HAN",
  },
  {
    city: "Harare - Harare International Airport",
    country: "Zimbabwe",
    value: "HRE",
  },
  {
    city: "Harbin (Haerbin)",
    country: "Heilongjiang, PR China",
    value: "HRB",
  },
  {
    city: "Harlingen/South Padre Island (TX)",
    country: "USA",
    value: "HRL",
  },
  {
    city: "Harrington Harbour, PQ",
    country: "Canada",
    value: "YHR",
  },
  {
    city: "Harrisburg (PA) - Harrisburg Skyport",
    country: "USA",
    value: "HAR",
  },
  {
    city: "Harrisburg (PA) - Harrisburg International",
    country: "USA",
    value: "MDT",
  },
  {
    city: "Hartford (CT) /Springfield (MA)",
    country: "USA",
    value: "BDL",
  },
  {
    city: "Hatyai (Hat Yai)",
    country: "Thailand",
    value: "HDY",
  },
  {
    city: "Haugesund",
    country: "Norway",
    value: "HAU",
  },
  {
    city: "Havana - José Martí International",
    country: "Cuba",
    value: "HAV",
  },
  {
    city: "Havre (MT)",
    country: "USA",
    value: "HVR",
  },
  {
    city: "Hayman Island",
    country: "Australia",
    value: "HIS",
  },
  {
    city: "Helena (MT)",
    country: "USA",
    value: "HLN",
  },
  {
    city: "Helsingborg",
    country: "Sweden",
    value: "JHE",
  },
  {
    city: "Helsinki - Vantaa",
    country: "Finland",
    value: "HEL",
  },
  {
    city: "Heraklion",
    country: "Greece",
    value: "HER",
  },
  {
    city: "Hermosillo - Gen. Pesqueira Garcia",
    country: "Mexico",
    value: "HMO",
  },
  {
    city: "Hervey Bay",
    country: "Australia",
    value: "HVB",
  },
  {
    city: "Hibbing (MN)",
    country: "USA",
    value: "HIB",
  },
  {
    city: "Hickory (NC)",
    country: "USA",
    value: "HKY",
  },
  {
    city: "Hilo (HI)",
    country: "USA",
    value: "ITO",
  },
  {
    city: "Hilton Head Island (SC)",
    country: "USA",
    value: "HHH",
  },
  {
    city: "Hinchinbrook Island",
    country: "Australia",
    value: "HNK",
  },
  {
    city: "Hiroshima International",
    country: "Japan",
    value: "HIJ",
  },
  {
    city: "Ho Chi Minh city (Saigon) - Tan Son Nhat International",
    country: "Viet Nam",
    value: "SGN",
  },
  {
    city: "Hobart",
    country: "Australia",
    value: "HBA",
  },
  {
    city: "Hof",
    country: "Germany",
    value: "HOQ",
  },
  {
    city: "Holguin",
    country: "Cuba",
    value: "HOG",
  },
  {
    city: "Home Hill",
    country: "Australia",
    value: "HMH",
  },
  {
    city: "Homer (AK)",
    country: "USA",
    value: "HOM",
  },
  {
    city: "Hong Kong - International Airport (HKIA)",
    country: "Hong Kong",
    value: "HKG",
  },
  {
    city: "Hong Kong - Chek Lap Kok",
    country: "Hong Kong",
    value: "ZJK",
  },
  {
    city: "Honiara Henderson International",
    country: "Solomon Islands",
    value: "HIR",
  },
  {
    city: "Honolulu (HI) - Honolulu International Airport",
    country: "USA",
    value: "HNL",
  },
  {
    city: "Hoonah (AK)",
    country: "USA",
    value: "HNH",
  },
  {
    city: "Horta",
    country: "Portugal",
    value: "HOR",
  },
  {
    city: "Houston (TX) , Hobby",
    country: "USA",
    value: "HOU",
  },
  {
    city: "Houston, TX - George Bush Intercontinental Airport",
    country: "USA",
    value: "IAH",
  },
  {
    city: "Huahine",
    country: "French Polynesia",
    value: "HUH",
  },
  {
    city: "Huatulco",
    country: "Mexico",
    value: "HUX",
  },
  {
    city: "Hue - Phu Bai",
    country: "Viet Nam",
    value: "HUI",
  },
  {
    city: "Humberside",
    country: "United Kingdom",
    value: "HUY",
  },
  {
    city: "Huntington (WV)",
    country: "USA",
    value: "HTS",
  },
  {
    city: "Huntsville (AL)",
    country: "USA",
    value: "HSV",
  },
  {
    city: "Hurghada International",
    country: "Egypt",
    value: "HRG",
  },
  {
    city: "Huron (SD)",
    country: "USA",
    value: "HON",
  },
  {
    city: "Hwange National Park",
    country: "Zimbabwe",
    value: "HWN",
  },
  {
    city: "Hyannis (MA)",
    country: "USA",
    value: "HYA",
  },
  {
    city: "Hydaburg (AK)",
    country: "USA",
    value: "HYG",
  },
  {
    city: "Hyderabad - Rajiv Gandhi International Airport",
    country: "India",
    value: "HYD",
  },
  {
    city: "Hyderabad",
    country: "Pakistan",
    value: "HDD",
  },
  {
    city: "Ibiza",
    country: "Ibiza/Spain",
    value: "IBZ",
  },
  {
    city: "Idaho Falls (ID)",
    country: "USA",
    value: "IDA",
  },
  {
    city: "Iguazu, Cataratas",
    country: "Argentina",
    value: "IGR",
  },
  {
    city: "Ile des Pins",
    country: "New Caledonia",
    value: "ILP",
  },
  {
    city: "Ile Ouen",
    country: "New Caledonia",
    value: "IOU",
  },
  {
    city: "Iliamna (AK)",
    country: "USA",
    value: "ILI",
  },
  {
    city: "Imperial (CA)",
    country: "USA",
    value: "IPL",
  },
  {
    city: "Incercargill",
    country: "New Zealand",
    value: "IVC",
  },
  {
    city: "Incheon, Incheon International Airport",
    country: "Korea South",
    value: "ICN",
  },
  {
    city: "Indianapolis (IN) International",
    country: "USA",
    value: "IND",
  },
  {
    city: "Ingham",
    country: "Australia",
    value: "IGH",
  },
  {
    city: "Innisfail",
    country: "Australia",
    value: "IFL",
  },
  {
    city: "Innsbruck - Kranebitten",
    country: "Austria",
    value: "INN",
  },
  {
    city: "International Falls (MN)",
    country: "USA",
    value: "INL",
  },
  {
    city: "Inuvik",
    country: "Canada",
    value: "YEV",
  },
  {
    city: "Invercargill",
    country: "New Zealand",
    value: "IVC",
  },
  {
    city: "Inverness",
    country: "United Kingdom",
    value: "INV",
  },
  {
    city: "Inykern (CA)",
    country: "USA",
    value: "IYK",
  },
  {
    city: "Iqaluit (Frobisher Bay)",
    country: "Canada",
    value: "YFB",
  },
  {
    city: "Iquitos",
    country: "Peru",
    value: "IQT",
  },
  {
    city: "Irkutsk",
    country: "Russia",
    value: "IKT",
  },
  {
    city: "Ishigaki - New Ishigaki Airport",
    country: "Japan",
    value: "ISG",
  },
  {
    city: "Islamabad - Benazir Bhutto International Airport",
    country: "Pakistan",
    value: "ISB",
  },
  {
    city: "Islay",
    country: "United Kingdom",
    value: "ILY",
  },
  {
    city: "Isle of Man",
    country: "",
    value: "IOM",
  },
  {
    city: "Istanbul - Istanbul Atatürk Airport",
    country: "Turkey",
    value: "IST",
  },
  {
    city: "Istanbul - Sabiha Gokcen",
    country: "Turkey",
    value: "SAW",
  },
  {
    city: "Ithaca/Cortland (NY)",
    country: "USA",
    value: "ITH",
  },
  {
    city: "Ivalo",
    country: "Finland",
    value: "IVL",
  },
  {
    city: "Ixtapa/Zihuatenejo",
    country: "Mexico",
    value: "ZIH",
  },
  {
    city: "Izmir",
    country: "Turkey",
    value: "IZM",
  },
  {
    city: "Izmir - Adnan Menderes Airport",
    country: "Turkey",
    value: "ADB",
  },
  {
    city: "Jackson Hole (WY)",
    country: "USA",
    value: "JAC",
  },
  {
    city: "Jackson (MI) - Reynolds Municipal",
    country: "USA",
    value: "JXN",
  },
  {
    city: "Jackson, MN",
    country: "USA",
    value: "MJQ",
  },
  {
    city: "Jackson (MS) - Jackson Internationall",
    country: "USA",
    value: "JAN",
  },
  {
    city: "Jackson (MS) - Hawkins Field",
    country: "USA",
    value: "HKS",
  },
  {
    city: "Jackson (TN) - Mckellar",
    country: "USA",
    value: "MKL",
  },
  {
    city: "Jackson Hole (WY)",
    country: "USA",
    value: "JAC",
  },
  {
    city: "Jacksonville (AR) Little Rock AFB",
    country: "USA",
    value: "LRF",
  },
  {
    city: "Jacksonville (FL) - Cecil Field NAS",
    country: "USA",
    value: "NZC",
  },
  {
    city: "Jacksonville (FL) Jacksonville NAS",
    country: "USA",
    value: "NIP",
  },
  {
    city: "Jacksonville (FL) - International",
    country: "USA",
    value: "JAX",
  },
  {
    city: "Jacksonville (FL) - Craig Municipal",
    country: "USA",
    value: "CRG",
  },
  {
    city: "Jacksonville (IL) - Municipal Airport",
    country: "USA",
    value: "IJX",
  },
  {
    city: "Jacksonville (NC)",
    country: "USA",
    value: "OAJ",
  },
  {
    city: "Jacksonville (TX)",
    country: "USA",
    value: "JKV",
  },
  {
    city: "Jacmel",
    country: "Haiti",
    value: "JAK",
  },
  {
    city: "Jacobabad",
    country: "Pakistan",
    value: "JAG",
  },
  {
    city: "Jacobina",
    country: "Brazil",
    value: "JCM",
  },
  {
    city: "Jacquinot Bay",
    country: "Papua New Guinea",
    value: "JAQ",
  },
  {
    city: "Jaffna - Kankesanturai",
    country: "Sri Lanka",
    value: "JAF",
  },
  {
    city: "Jagdalpur",
    country: "India",
    value: "JGB",
  },
  {
    city: "Jaipur - Sanganeer",
    country: "India",
    value: "JAI",
  },
  {
    city: "Jaisalmer",
    country: "India",
    value: "JSA",
  },
  {
    city: "Jakarta - Halim Perdana Kusuma",
    country: "Indonesia",
    value: "HLP",
  },
  {
    city: "Jakarta - Metropolitan Area",
    country: "Indonesia",
    value: "JKT",
  },
  {
    city: "Jakarta - Soekarno-Hatta International",
    country: "Indonesia",
    value: "CGK",
  },
  {
    city: "Jalalabad",
    country: "Afghanistan",
    value: "JAA",
  },
  {
    city: "Jalandhar",
    country: "India",
    value: "JLR",
  },
  {
    city: "Jalapa",
    country: "Mexico",
    value: "JAL",
  },
  {
    city: "Jales",
    country: "Brazil",
    value: "JLS",
  },
  {
    city: "Jaluit Island",
    country: "Marshall Islands",
    value: "UIT",
  },
  {
    city: "Jamba",
    country: "Angola",
    value: "JMB",
  },
  {
    city: "Jambi - Sultan Taha Syarifudn",
    country: "Indonesia",
    value: "DJB",
  },
  {
    city: "Jambol",
    country: "Bulgaria",
    value: "JAM",
  },
  {
    city: "Jamestown (ND)",
    country: "USA",
    value: "JMS",
  },
  {
    city: "Jamestown (NY)",
    country: "USA",
    value: "JHW",
  },
  {
    city: "Jammu - Satwari",
    country: "India",
    value: "IXJ",
  },
  {
    city: "Jamnagar - Govardhanpur",
    country: "India",
    value: "JGA",
  },
  {
    city: "Jamshedpur - Sonari Airport",
    country: "India",
    value: "IXW",
  },
  {
    city: "Janakpur",
    country: "Nepal",
    value: "JKR",
  },
  {
    city: "Jandakot",
    country: "Australia",
    value: "JAD",
  },
  {
    city: "Janesville (WI) - Rock County",
    country: "USA",
    value: "JVL",
  },
  {
    city: "Januaria",
    country: "Brazil",
    value: "JNA",
  },
  {
    city: "Jaque",
    country: "Panama",
    value: "JQE",
  },
  {
    city: "Jatai",
    country: "Brazil",
    value: "JTI",
  },
  {
    city: "Jauja",
    country: "Peru",
    value: "JAU",
  },
  {
    city: "Jayapura - Sentani",
    country: "Indonesia",
    value: "DJJ",
  },
  {
    city: "Jeddah - King Abdulaziz International",
    country: "Saudi Arabia",
    value: "JED",
  },
  {
    city: "Jefferson city (MO) - Jefferson Memorial",
    country: "USA",
    value: "JEF",
  },
  {
    city: "Jeremie - Jeremie Airport",
    country: "Haiti",
    value: "JEE",
  },
  {
    city: "Jerez de la Frontera/Cadiz - La Parra",
    country: "Spain",
    value: "XRY",
  },
  {
    city: "Jersey",
    country: "Channel Islands",
    value: "JER",
  },
  {
    city: "Jerusalem - Atarot Airport (closed)",
    country: "Israel",
    value: "JRS",
  },
  {
    city: "Jessore - Jessore Airport",
    country: "Bangladesh",
    value: "JSR",
  },
  {
    city: "Jeypore - Jeypore Airport",
    country: "India",
    value: "PYB",
  },
  {
    city: "Ji'an",
    country: "Jiangxi, China",
    value: "JGS",
  },
  {
    city: "Jiamusi - Jiamusi Airport",
    country: "PR China",
    value: "JMU",
  },
  {
    city: "Jiayuguan - Jiayuguan Airport",
    country: "PR China",
    value: "JGN",
  },
  {
    city: "Jijel",
    country: "Algeria",
    value: "GJL",
  },
  {
    city: "Jijiga",
    country: "Ethiopia",
    value: "JIJ",
  },
  {
    city: "Jilin",
    country: "PR China",
    value: "JIL",
  },
  {
    city: "Jimma",
    country: "Ethiopia",
    value: "JIM",
  },
  {
    city: "Jinan",
    country: "Shandong, PR China",
    value: "TNA",
  },
  {
    city: "Jingdezhen",
    country: "PR China",
    value: "JDZ",
  },
  {
    city: "Jinghong - Gasa Airport",
    country: "PR China",
    value: "JHG",
  },
  {
    city: "Jining",
    country: "PR China",
    value: "JNG",
  },
  {
    city: "Jinja",
    country: "Uganda",
    value: "JIN",
  },
  {
    city: "Jinjiang",
    country: "PR China",
    value: "JJN",
  },
  {
    city: "Jinka - Baco/Jinka Airport",
    country: "Ethiopia",
    value: "BCO",
  },
  {
    city: "Jinzhou - Jinzhou Airport",
    country: "PR China",
    value: "JNZ",
  },
  {
    city: "Jipijapa",
    country: "Ecuador",
    value: "JIP",
  },
  {
    city: "Jiri",
    country: "Nepal",
    value: "JIR",
  },
  {
    city: "Jiujiang - Jiujiang Lushan Airport",
    country: "PR China",
    value: "JIU",
  },
  {
    city: "Jiwani",
    country: "Pakistan",
    value: "JIW",
  },
  {
    city: "Joacaba",
    country: "Brazil",
    value: "JCB",
  },
  {
    city: "Joao Pessoa - Castro Pinto Airport",
    country: "Brazil",
    value: "JPA",
  },
  {
    city: "Jodhpur",
    country: "India",
    value: "JDH",
  },
  {
    city: "Jönköping (Jonkoping) - Axamo Airport",
    country: "Sweden",
    value: "JKG",
  },
  {
    city: "Joensuu",
    country: "Finland",
    value: "JOE",
  },
  {
    city: "Johannesburg - OR Tambo International Airport",
    country: "South Africa",
    value: "JNB",
  },
  {
    city: "Johnson city (NY) - Binghamton/Endicott/Johnson",
    country: "USA",
    value: "BGM",
  },
  {
    city: "Johnston Island",
    country: "USA",
    value: "JON",
  },
  {
    city: "Johnstown (PA)",
    country: "USA",
    value: "JST",
  },
  {
    city: "Johor Bahru - Sultan Ismail International",
    country: "Malaysia",
    value: "JHB",
  },
  {
    city: "Joinville - Cubatao Airport",
    country: "Brazil",
    value: "JOI",
  },
  {
    city: "Jolo",
    country: "Philippines",
    value: "JOL",
  },
  {
    city: "Jomsom",
    country: "Nepal",
    value: "JMO",
  },
  {
    city: "Jonesboro (AR) Jonesboro Airport",
    country: "USA",
    value: "JBR",
  },
  {
    city: "Joplin (MO)",
    country: "USA",
    value: "JLN",
  },
  {
    city: "Jorhat - Rowriah Airport",
    country: "India",
    value: "JRH",
  },
  {
    city: "Jos",
    country: "Nigeria",
    value: "JOS",
  },
  {
    city: "Jose De San Martin",
    country: "Argentina",
    value: "JSM",
  },
  {
    city: "Jouf",
    country: "Saudi Arabia",
    value: "AJF",
  },
  {
    city: "Juanjui",
    country: "Peru",
    value: "JJI",
  },
  {
    city: "Juba",
    country: "South Sudan",
    value: "JUB",
  },
  {
    city: "Juist (island)",
    country: "Germany",
    value: "JUI",
  },
  {
    city: "Juiz De Fora - Francisco De Assis Airport",
    country: "Brazil",
    value: "JDF",
  },
  {
    city: "Jujuy - El Cadillal Airport",
    country: "Argentina",
    value: "JUJ",
  },
  {
    city: "Julia Creek",
    country: "Australia",
    value: "JCK",
  },
  {
    city: "Juliaca",
    country: "Peru",
    value: "JUL",
  },
  {
    city: "Jumla",
    country: "Nepal",
    value: "JUM",
  },
  {
    city: "Jundah",
    country: "Australia",
    value: "JUN",
  },
  {
    city: "Juneau (AK) - Juneau International Airport",
    country: "USA",
    value: "JNU",
  },
  {
    city: "Junin",
    country: "Argentina",
    value: "JNI",
  },
  {
    city: "Juticalpa",
    country: "Honduras",
    value: "JUT",
  },
  {
    city: "Jwaneng",
    country: "Botswana",
    value: "JWA",
  },
  {
    city: "Jyväskylä (Jyvaskyla)",
    country: "Finland",
    value: "JYV",
  },
  {
    city: "Kabul - Khwaja Rawash Airport",
    country: "Afghanistan",
    value: "KBL",
  },
  {
    city: "Kagoshima",
    country: "Japan",
    value: "KOJ",
  },
  {
    city: "Kahramanmaras",
    country: "Turkey",
    value: "KCM",
  },
  {
    city: "Kahului (HI)",
    country: "USA",
    value: "OGG",
  },
  {
    city: "Kajaani",
    country: "Finland",
    value: "KAJ",
  },
  {
    city: "Kalamata",
    country: "Greece",
    value: "KLX",
  },
  {
    city: "Kalamazoo/Battle Creek (MI)",
    country: "USA",
    value: "AZO",
  },
  {
    city: "Kalgoorlie",
    country: "Australia",
    value: "KGI",
  },
  {
    city: "Kaliningrad",
    country: "Russia",
    value: "KGD",
  },
  {
    city: "Kalispell (MT)",
    country: "USA",
    value: "FCA",
  },
  {
    city: "Kalmar",
    country: "Sweden",
    value: "KLR",
  },
  {
    city: "Kamloops, BC",
    country: "Canada",
    value: "YKA",
  },
  {
    city: "Kamuela (HI)",
    country: "USA",
    value: "MUE",
  },
  {
    city: "Kano",
    country: "Nigeria",
    value: "KAN",
  },
  {
    city: "Kanpur",
    country: "India",
    value: "KNU",
  },
  {
    city: "Kansas city (MO) - Kansas city International Airport",
    country: "USA",
    value: "MCI",
  },
  {
    city: "Kaohsiung International",
    country: "Taiwan",
    value: "KHH",
  },
  {
    city: "Kapalua West (HI)",
    country: "USA",
    value: "JHM",
  },
  {
    city: "Karachi - Jinnah International Airport",
    country: "Pakistan",
    value: "KHI",
  },
  {
    city: "Karlsruhe-Baden - Soellingen",
    country: "Germany",
    value: "FKB",
  },
  {
    city: "Karlstad",
    country: "Sweden",
    value: "KSD",
  },
  {
    city: "Karpathos",
    country: "Greece",
    value: "AOK",
  },
  {
    city: "Karratha",
    country: "Australia",
    value: "KTA",
  },
  {
    city: "Kars",
    country: "Turkey",
    value: "KYS",
  },
  {
    city: "Karumba",
    country: "Australia",
    value: "KRB",
  },
  {
    city: "Karup",
    country: "Denmark",
    value: "KRP",
  },
  {
    city: "Kaschechawan, PQ",
    country: "Canada",
    value: "ZKE",
  },
  {
    city: "Kassala",
    country: "Sudan",
    value: "KSL",
  },
  {
    city: "Katherine",
    country: "Australia",
    value: "KTR",
  },
  {
    city: "Kathmandu - Tribhuvan International Airport",
    country: "Nepal",
    value: "KTM",
  },
  {
    city: "Katima Mulilo/Mpacha",
    country: "Namibia",
    value: "MPA",
  },
  {
    city: "Kauhajoki",
    country: "Finland",
    value: "KHJ",
  },
  {
    city: "Kaunakakai (HI)",
    country: "USA",
    value: "MKK",
  },
  {
    city: "Kavalla",
    country: "Greece",
    value: "KVA",
  },
  {
    city: "Kayseri",
    country: "Turkey",
    value: "ASR",
  },
  {
    city: "Kazan - Kazan International Airport",
    country: "Russia",
    value: "KZN",
  },
  {
    city: "Keetmanshoop",
    country: "Namibia",
    value: "KMP",
  },
  {
    city: "Kelowna, BC",
    country: "Canada",
    value: "YLW",
  },
  {
    city: "Kemi/Tornio",
    country: "Finland",
    value: "KEM",
  },
  {
    city: "Kenai (AK)",
    country: "USA",
    value: "ENA",
  },
  {
    city: "Kent (Manston) Kent International",
    country: "United Kingdom",
    value: "MSE",
  },
  {
    city: "Kerry County",
    country: "Ireland",
    value: "KIR",
  },
  {
    city: "Ketchikan (AK)",
    country: "USA",
    value: "KTN",
  },
  {
    city: "Key West (FL)",
    country: "USA",
    value: "EYW",
  },
  {
    city: "Khamis Mushayat",
    country: "Saudi Arabia",
    value: "AHB",
  },
  {
    city: "Kharga - New Valley",
    country: "Egypt",
    value: "UVL",
  },
  {
    city: "Kharkov",
    country: "Ukraine",
    value: "HRK",
  },
  {
    city: "Khartoum - Khartoum International Airport",
    country: "Sudan",
    value: "KRT",
  },
  {
    city: "Khuzdar",
    country: "Pakistan",
    value: "KDD",
  },
  {
    city: "Kiel - Holtenau",
    country: "Germany",
    value: "KEL",
  },
  {
    city: "Kiev - Borispol",
    country: "Ukraine",
    value: "KBP",
  },
  {
    city: "Kiev - Zhulhany",
    country: "Ukraine",
    value: "IEV",
  },
  {
    city: "Kigali - Gregoire Kayibanda",
    country: "Rwanda",
    value: "KGL",
  },
  {
    city: "Kilimadjaro",
    country: "Tanzania",
    value: "JRO",
  },
  {
    city: "Killeem (TX)",
    country: "USA",
    value: "ILE",
  },
  {
    city: "Kimberley",
    country: "South Africa",
    value: "KIM",
  },
  {
    city: "King Island",
    country: "King Island (Australia)",
    value: "KNS",
  },
  {
    city: "King Salomon (AK)",
    country: "USA",
    value: "AKN",
  },
  {
    city: "Kingscote",
    country: "Australia",
    value: "KGC",
  },
  {
    city: "Kingston - Norman Manley",
    country: "Jamaica",
    value: "KIN",
  },
  {
    city: "Kingston (NC)",
    country: "USA",
    value: "ISO",
  },
  {
    city: "Kingstown - E. T. Joshua Airport",
    country: "Saint Vincent and the Grenadines",
    value: "SVD",
  },
  {
    city: "Kinshasa - N'Djili",
    country: "Congo (DRC)",
    value: "FIH",
  },
  {
    city: "Kiritimati (island) - Cassidy International Airport",
    country: "Kiribati",
    value: "CXI",
  },
  {
    city: "Kirkenes",
    country: "Norway",
    value: "KKN",
  },
  {
    city: "Kirkuk",
    country: "Iraq",
    value: "KIK",
  },
  {
    city: "Kirkwall (Orkney)",
    country: "United Kingdom",
    value: "KOI",
  },
  {
    city: "Kiruna",
    country: "Sweden",
    value: "KRN",
  },
  {
    city: "Kisangani",
    country: "Congo (DRC)",
    value: "FKI",
  },
  {
    city: "Kittilä",
    country: "Finland",
    value: "KTT",
  },
  {
    city: "Kitwe",
    country: "Zambia",
    value: "KIW",
  },
  {
    city: "Klagenfurt",
    country: "Austria",
    value: "KLU",
  },
  {
    city: "Klamath Fall (OR)",
    country: "USA",
    value: "LMT",
  },
  {
    city: "Klawock (AK)",
    country: "USA",
    value: "KLW",
  },
  {
    city: "Kleinsee",
    country: "South Africa",
    value: "KLZ",
  },
  {
    city: "Knock",
    country: "Ireland",
    value: "NOC",
  },
  {
    city: "Knoxville (TN)",
    country: "USA",
    value: "TYS",
  },
  {
    city: "Kobe",
    country: "Japan",
    value: "UKB",
  },
  {
    city: "Kochi",
    country: "Japan",
    value: "KCZ",
  },
  {
    city: "Köln, Köln/Bonn",
    country: "Germany",
    value: "CGN",
  },
  {
    city: "Kodiak (AK)",
    country: "USA",
    value: "ADQ",
  },
  {
    city: "Kohat",
    country: "Pakistan",
    value: "OHT",
  },
  {
    city: "Kokkola/Pietarsaari",
    country: "Finland",
    value: "KOK",
  },
  {
    city: "Kolkata (Calcutta) - Netaji Subhas Chandra",
    country: "India",
    value: "CCU",
  },
  {
    city: "Komatsu",
    country: "Japan",
    value: "KMQ",
  },
  {
    city: "Kona (HI)",
    country: "USA",
    value: "KOA",
  },
  {
    city: "Konya",
    country: "Turkey",
    value: "KYA",
  },
  {
    city: "Korhogo",
    country: "Cote d'Ivoire",
    value: "HGO",
  },
  {
    city: "Kos",
    country: "Greece",
    value: "KGS",
  },
  {
    city: "Kota Kinabalu",
    country: "Malaysia",
    value: "BKI",
  },
  {
    city: "Kotzbue (AK)",
    country: "USA",
    value: "OTZ",
  },
  {
    city: "Kowanyama",
    country: "Australia",
    value: "KWM",
  },
  {
    city: "Krakow (Cracow) - John Paul II International Airport",
    country: "Poland",
    value: "KRK",
  },
  {
    city: "Kristiansand",
    country: "Norway",
    value: "KRS",
  },
  {
    city: "Kristianstad",
    country: "Sweden",
    value: "KID",
  },
  {
    city: "Kristiansund",
    country: "Norway",
    value: "KSU",
  },
  {
    city: "Kuala Lumpur - International Airport",
    country: "Malaysia",
    value: "KUL",
  },
  {
    city: "Kuala Lumpur - Sultan Abdul Aziz Shah",
    country: "Malaysia",
    value: "SZB",
  },
  {
    city: "Kuantan",
    country: "Malaysia",
    value: "KUA",
  },
  {
    city: "Kuching",
    country: "Malaysia",
    value: "KCH",
  },
  {
    city: "Kumamoto",
    country: "Japan",
    value: "KMJ",
  },
  {
    city: "Kununurra",
    country: "Australia",
    value: "KNX",
  },
  {
    city: "Kuopio",
    country: "Finland",
    value: "KUO",
  },
  {
    city: "Kushiro",
    country: "Japan",
    value: "KUH",
  },
  {
    city: "Kuujjuaq (FortChimo)",
    country: "Canada",
    value: "YVP",
  },
  {
    city: "Kuujjuarapik",
    country: "Canada",
    value: "YGW",
  },
  {
    city: "Kuusamo",
    country: "Finland",
    value: "KAO",
  },
  {
    city: "Kuwait - Kuwait International",
    country: "Kuwait",
    value: "KWI",
  },
  {
    city: "Kyoto",
    country: "Japan",
    value: "UKY",
  },
  {
    city: "Labe",
    country: "Guinea",
    value: "LEK",
  },
  {
    city: "Labouchere Bay (AK)",
    country: "USA",
    value: "WLB",
  },
  {
    city: "Labuan",
    country: "Malaysia",
    value: "LBU",
  },
  {
    city: "Lac Brochet, MB",
    country: "Canada",
    value: "XLB",
  },
  {
    city: "La Coruna",
    country: "Spain",
    value: "LCG",
  },
  {
    city: "La Crosse (WI)",
    country: "USA",
    value: "LSE",
  },
  {
    city: "Lae - Lae Nadzab Airport",
    country: "Papua New Guinea",
    value: "LAE",
  },
  {
    city: "La Rochelle",
    country: "France",
    value: "LRH",
  },
  {
    city: "Lafayette (IN)",
    country: "USA",
    value: "LAF",
  },
  {
    city: "Lafayette, La",
    country: "USA",
    value: "LFT",
  },
  {
    city: "Lagos - Murtala Muhammed Airport",
    country: "Nigeria",
    value: "LOS",
  },
  {
    city: "La Grande",
    country: "Canada",
    value: "YGL",
  },
  {
    city: "Lahore",
    country: "Pakistan",
    value: "LHE",
  },
  {
    city: "Lake Charles (LA)",
    country: "USA",
    value: "LCH",
  },
  {
    city: "Lake Havasu city (AZ)",
    country: "USA",
    value: "HII",
  },
  {
    city: "Lake Tahoe (CA)",
    country: "USA",
    value: "TVL",
  },
  {
    city: "Lakselv",
    country: "Norway",
    value: "LKL",
  },
  {
    city: "Lambarene",
    country: "Gabon",
    value: "LBQ",
  },
  {
    city: "Lamezia Terme",
    country: "Italy",
    value: "SUF",
  },
  {
    city: "Lampedusa",
    country: "Italy",
    value: "LMP",
  },
  {
    city: "Lanai city (HI)",
    country: "USA",
    value: "LNY",
  },
  {
    city: "Lancaster (PA)",
    country: "USA",
    value: "LNS",
  },
  {
    city: "Land's End",
    country: "United Kingdom",
    value: "LEQ",
  },
  {
    city: "Langkawi (islands)",
    country: "Malaysia",
    value: "LGK",
  },
  {
    city: "Lannion",
    country: "France",
    value: "LAI",
  },
  {
    city: "Lanseria",
    country: "South Africa",
    value: "HLA",
  },
  {
    city: "Lansing (MI)",
    country: "USA",
    value: "LAN",
  },
  {
    city: "La Paz - El Alto",
    country: "Bolivia",
    value: "LPB",
  },
  {
    city: "La Paz - Leon",
    country: "Mexico",
    value: "LAP",
  },
  {
    city: "Lappeenranta",
    country: "Finland",
    value: "LPP",
  },
  {
    city: "Laramie (WY)",
    country: "USA",
    value: "LAR",
  },
  {
    city: "Laredo (TX)",
    country: "USA",
    value: "LRD",
  },
  {
    city: "Larnaca",
    country: "Cyprus",
    value: "LCA",
  },
  {
    city: "Las Palmas",
    country: "Spain",
    value: "LPA",
  },
  {
    city: "Las Vegas (NV)",
    country: "USA",
    value: "LAS",
  },
  {
    city: "Latrobe (PA)",
    country: "USA",
    value: "LBE",
  },
  {
    city: "Launceston",
    country: "Australia",
    value: "LST",
  },
  {
    city: "Laurel/Hattisburg (MS)",
    country: "USA",
    value: "PIB",
  },
  {
    city: "Laverton",
    country: "Australia",
    value: "LVO",
  },
  {
    city: "Lawton (OK)",
    country: "USA",
    value: "LAW",
  },
  {
    city: "Lazaro Cardenas",
    country: "Mexico",
    value: "LZC",
  },
  {
    city: "Leaf Rapids",
    country: "Canada",
    value: "YLR",
  },
  {
    city: "Learmouth (Exmouth)",
    country: "Australia",
    value: "LEA",
  },
  {
    city: "Lebanon (NH)",
    country: "USA",
    value: "LEB",
  },
  {
    city: "Leeds/Bradford",
    country: "United Kingdom",
    value: "LBA",
  },
  {
    city: "Leinster",
    country: "Australia",
    value: "LER",
  },
  {
    city: "Leipzig",
    country: "Germany",
    value: "LEJ",
  },
  {
    city: "Lelystad",
    country: "Netherlands",
    value: "LEY",
  },
  {
    city: "Leon",
    country: "Mexico",
    value: "BJX",
  },
  {
    city: "Leonora",
    country: "Australia",
    value: "LNO",
  },
  {
    city: "Lerwick/Tingwall (Shetland Islands)",
    country: "United Kingdom",
    value: "LWK",
  },
  {
    city: "Lewiston (ID)",
    country: "USA",
    value: "LWS",
  },
  {
    city: "Lewistown (MT)",
    country: "USA",
    value: "LWT",
  },
  {
    city: "Lexington (KY)",
    country: "USA",
    value: "LEX",
  },
  {
    city: "Libreville",
    country: "Gabon",
    value: "LBV",
  },
  {
    city: "Lidkoeping",
    country: "Sweden",
    value: "LDK",
  },
  {
    city: "Liege",
    country: "Belgium",
    value: "LGG",
  },
  {
    city: "Lifou",
    country: "Loyaute, Pazifik",
    value: "LIF",
  },
  {
    city: "Lihue (HI)",
    country: "USA",
    value: "LIH",
  },
  {
    city: "Lille - Lille Airport",
    country: "France",
    value: "LIL",
  },
  {
    city: "Lilongwe - Lilongwe International",
    country: "Malawi",
    value: "LLW",
  },
  {
    city: "Lima - J Chavez International",
    country: "Peru",
    value: "LIM",
  },
  {
    city: "Limassol",
    country: "Cyprus",
    value: "QLI",
  },
  {
    city: "Limoges",
    country: "France",
    value: "LIG",
  },
  {
    city: "Lincoln (NE)",
    country: "USA",
    value: "LNK",
  },
  {
    city: "Lindeman Island",
    country: "Australia",
    value: "LDC",
  },
  {
    city: "Linz - Hoersching",
    country: "Austria",
    value: "LNZ",
  },
  {
    city: "Lisala",
    country: "Congo (DRC)",
    value: "LIQ",
  },
  {
    city: "Lisbon - Lisboa",
    country: "Portugal",
    value: "LIS",
  },
  {
    city: "Lismore",
    country: "Australia",
    value: "LSY",
  },
  {
    city: "Little Rock (AR)",
    country: "USA",
    value: "LIT",
  },
  {
    city: "Liverpool",
    country: "United Kingdom",
    value: "LPL",
  },
  {
    city: "Lizard Island",
    country: "Australia",
    value: "LZR",
  },
  {
    city: "Ljubljana - Brnik",
    country: "Slovenia",
    value: "LJU",
  },
  {
    city: "Lockhart River",
    country: "Australia",
    value: "IRG",
  },
  {
    city: "Lome",
    country: "Togo",
    value: "LFW",
  },
  {
    city: "London",
    country: "Canada",
    value: "YXU",
  },
  {
    city: "London Metropolitan Area",
    country: "United Kingdom",
    value: "LON",
  },
  {
    city: "London - city Airport",
    country: "United Kingdom",
    value: "LCY",
  },
  {
    city: "London - Gatwick",
    country: "United Kingdom",
    value: "LGW",
  },
  {
    city: "London - Heathrow",
    country: "United Kingdom",
    value: "LHR",
  },
  {
    city: "London - Luton",
    country: "United Kingdom",
    value: "LTN",
  },
  {
    city: "London - Stansted",
    country: "United Kingdom",
    value: "STN",
  },
  {
    city: "Londonderry - Eglinton",
    country: "United Kingdom",
    value: "LDY",
  },
  {
    city: "Long Beach (CA)",
    country: "USA",
    value: "LGB",
  },
  {
    city: "Long Island (AK)",
    country: "USA",
    value: "LIJ",
  },
  {
    city: "Long Island, Islip (NY) - Mac Arthur",
    country: "USA",
    value: "ISP",
  },
  {
    city: "Longreach",
    country: "Australia",
    value: "LRE",
  },
  {
    city: "Longview/Kilgore (TX)",
    country: "USA",
    value: "GGG",
  },
  {
    city: "Longyearbyen - Svalbard",
    country: "Svalbard/Norway",
    value: "LYR",
  },
  {
    city: "Loreto",
    country: "Mexico",
    value: "LTO",
  },
  {
    city: "Lorient",
    country: "France",
    value: "LRT",
  },
  {
    city: "Los Angeles (CA) - International",
    country: "USA",
    value: "LAX",
  },
  {
    city: "Los Cabos",
    country: "Mexico",
    value: "SJD",
  },
  {
    city: "Los Mochis",
    country: "Mexico",
    value: "LMM",
  },
  {
    city: "Los Rodeos",
    country: "Teneriffa/Spain",
    value: "TFN",
  },
  {
    city: "Losinj - Losinj Arpt",
    country: "Croatia (Hrvatska)",
    value: "LSZ",
  },
  {
    city: "Lourdes/Tarbes",
    country: "France",
    value: "LDE",
  },
  {
    city: "Louisville (KY)",
    country: "USA",
    value: "SDF",
  },
  {
    city: "Luanda - 4 de Fevereiro",
    country: "Angola",
    value: "LAD",
  },
  {
    city: "Lubbock (TX)",
    country: "USA",
    value: "LBB",
  },
  {
    city: "Lucknow",
    country: "India",
    value: "LKO",
  },
  {
    city: "Luederitz",
    country: "Namibia",
    value: "LUD",
  },
  {
    city: "Luga",
    country: "Malta",
    value: "MLA",
  },
  {
    city: "Lugano",
    country: "Switzerland",
    value: "LUG",
  },
  {
    city: "Lulea",
    country: "Sweden",
    value: "LLA",
  },
  {
    city: "Lumbumbashi",
    country: "Congo (DRC)",
    value: "FBM",
  },
  {
    city: "Lusaka - Lusaka International Airport",
    country: "Zambia",
    value: "LUN",
  },
  {
    city: "Lusisiki",
    country: "South Africa",
    value: "LUJ",
  },
  {
    city: "Luxembourg",
    country: "Luxembourg",
    value: "LUX",
  },
  {
    city: "Luxi - Mangshi",
    country: "Yunnan, PR China",
    value: "LUM",
  },
  {
    city: "Luxor",
    country: "Egypt",
    value: "LXR",
  },
  {
    city: "Lvov (Lwow, Lemberg)",
    country: "Ukraine",
    value: "LWO",
  },
  {
    city: "Lydd - Lydd International Airport",
    country: "United Kingdom",
    value: "LYX",
  },
  {
    city: "Lynchburg (VA)",
    country: "USA",
    value: "LYH",
  },
  {
    city: "Lyon - Lyon-Saint Exupéry Airport",
    country: "France",
    value: "LYS",
  },
  {
    city: "Lyons (KS) - Rice County Municipal",
    country: "USA",
    value: "LYO",
  },
  {
    city: "Maastricht/Aachen",
    country: "Netherlands",
    value: "MST",
  },
  {
    city: "Macapa - Alberto Alcolumbre International Airport",
    country: "Brazil",
    value: "MCP",
  },
  {
    city: "Macau - Macau International Airport",
    country: "Macau, China SAR",
    value: "MFM",
  },
  {
    city: "Maceio - Zumbi dos Palmares International Airport",
    country: "Brazil",
    value: "MCZ",
  },
  {
    city: "Mackay",
    country: "Australia",
    value: "MKY",
  },
  {
    city: "Macon (GA)",
    country: "USA",
    value: "MCN",
  },
  {
    city: "Mactan Island - Nab",
    country: "Philippines",
    value: "NOP",
  },
  {
    city: "Madinah (Medina) - Mohammad Bin Abdulaziz",
    country: "Saudi Arabia",
    value: "MED",
  },
  {
    city: "Madison (WI) - Dane County Regional Airport",
    country: "USA",
    value: "MSN",
  },
  {
    city: "Madras (Chennai) - Chennai International Airport",
    country: "India",
    value: "MAA",
  },
  {
    city: "Madrid - Barajas Airport",
    country: "Spain",
    value: "MAD",
  },
  {
    city: "Mahe - Seychelles International",
    country: "Seychelles",
    value: "SEZ",
  },
  {
    city: "Mahon",
    country: "Spain",
    value: "MAH",
  },
  {
    city: "Maitland",
    country: "Australia",
    value: "MTL",
  },
  {
    city: "Majunga",
    country: "Madagascar",
    value: "MJN",
  },
  {
    city: "Makung",
    country: "Taiwan",
    value: "MZG",
  },
  {
    city: "Malabo - Malabo International Airport",
    country: "Equatorial Guinea",
    value: "SSG",
  },
  {
    city: "Malaga",
    country: "Spain",
    value: "AGP",
  },
  {
    city: "Malatya",
    country: "Turkey",
    value: "MLX",
  },
  {
    city: "Male - Velana International Airport",
    country: "Maledives",
    value: "MLE",
  },
  {
    city: "Malindi",
    country: "Kenya",
    value: "MYD",
  },
  {
    city: "Malmo (Malmoe)",
    country: "Sweden",
    value: "MMA",
  },
  {
    city: "Malmo (Malmö) - Malmö Airport",
    country: "Sweden",
    value: "MMX",
  },
  {
    city: "Man",
    country: "Cote d'Ivoire",
    value: "MJC",
  },
  {
    city: "Managua - Augusto C Sandino",
    country: "Nicaragua",
    value: "MGA",
  },
  {
    city: "Manaus - Eduardo Gomes International Airport",
    country: "Brazil",
    value: "MAO",
  },
  {
    city: "Manchester",
    country: "United Kingdom",
    value: "MAN",
  },
  {
    city: "Manchester (NH)",
    country: "USA",
    value: "MHT",
  },
  {
    city: "Mandalay - Mandalay-Annisaton Airport",
    country: "Myanmar",
    value: "MDL",
  },
  {
    city: "Manguna",
    country: "Papua New Guinea",
    value: "MFO",
  },
  {
    city: "Manihi",
    country: "French Polynesia",
    value: "XMH",
  },
  {
    city: "Manila - Ninoy Aquino International",
    country: "Philippines",
    value: "MNL",
  },
  {
    city: "Manzanillo",
    country: "Mexico",
    value: "ZLO",
  },
  {
    city: "Manzini - Matsapha International",
    country: "Swaziland",
    value: "MTS",
  },
  {
    city: "Maputo - Maputo International",
    country: "Mozambique",
    value: "MPM",
  },
  {
    city: "Mar del Plata",
    country: "Argentina",
    value: "MDQ",
  },
  {
    city: "Maracaibo - La Chinita International",
    country: "Venezuela",
    value: "MAR",
  },
  {
    city: "Maradi",
    country: "Niger",
    value: "MFQ",
  },
  {
    city: "Maras",
    country: "Turkey",
    value: "KCM",
  },
  {
    city: "Marathon (FL)",
    country: "USA",
    value: "MTH",
  },
  {
    city: "Mardin",
    country: "Turkey",
    value: "MQM",
  },
  {
    city: "Mare",
    country: "New Caledonia",
    value: "MEE",
  },
  {
    city: "Margate",
    country: "South Africa",
    value: "MGH",
  },
  {
    city: "Margerita",
    country: "Venezuela",
    value: "PMV",
  },
  {
    city: "Maribor",
    country: "Slovenia",
    value: "MBX",
  },
  {
    city: "Mariehamn (Maarianhamina)",
    country: "Finland",
    value: "MHQ",
  },
  {
    city: "Maroua",
    country: "Cameroon",
    value: "MVR",
  },
  {
    city: "Marquette (MI)",
    country: "USA",
    value: "MQT",
  },
  {
    city: "Marrakesh - Menara Airport",
    country: "Morocco",
    value: "RAK",
  },
  {
    city: "Marsa Alam",
    country: "Egypt",
    value: "RMF",
  },
  {
    city: "Marsa Matrah (Marsa Matruh)",
    country: "Egypt",
    value: "MUH",
  },
  {
    city: "Marseille - Marseille Provence Airport",
    country: "France",
    value: "MRS",
  },
  {
    city: "Marsh Harbour",
    country: "Bahamas",
    value: "MHH",
  },
  {
    city: "Martha's Vineyard (MA)",
    country: "USA",
    value: "MVY",
  },
  {
    city: "Martinsburg (WV)",
    country: "USA",
    value: "MRB",
  },
  {
    city: "Maryborough",
    country: "Australia",
    value: "MBH",
  },
  {
    city: "Maseru - Moshoeshoe International",
    country: "Lesotho",
    value: "MSU",
  },
  {
    city: "Mason city IA",
    country: "USA",
    value: "MCW",
  },
  {
    city: "Masvingo",
    country: "Zimbabwe",
    value: "MVZ",
  },
  {
    city: "Matsumoto, Nagano",
    country: "Japan",
    value: "MMJ",
  },
  {
    city: "Matsuyama",
    country: "Japan",
    value: "MYJ",
  },
  {
    city: "Mattoon (IL)",
    country: "USA",
    value: "MTO",
  },
  {
    city: "Maun",
    country: "Botswana",
    value: "MUB",
  },
  {
    city: "Maupiti",
    country: "French Polynesia",
    value: "MAU",
  },
  {
    city: "Mauritius - S.Seewoosagur Ram International",
    country: "Mauritius",
    value: "MRU",
  },
  {
    city: "Mayaguez",
    country: "Puerto Rico",
    value: "MAZ",
  },
  {
    city: "Mazatlan",
    country: "Mexico",
    value: "MZT",
  },
  {
    city: "McAllen (TX)",
    country: "USA",
    value: "MFE",
  },
  {
    city: "Medan - Polania Int'l (now Soewondo AFB)",
    country: "Indonesia",
    value: "MES",
  },
  {
    city: "Medan - Kualanamu International",
    country: "Indonesia",
    value: "KNO",
  },
  {
    city: "Medellin - José María Córdova International",
    country: "Colombia",
    value: "MDE",
  },
  {
    city: "Medford (OR)",
    country: "USA",
    value: "MFR",
  },
  {
    city: "Medina",
    country: "Saudi Arabia",
    value: "MED",
  },
  {
    city: "Meekatharra",
    country: "Australia",
    value: "MKR",
  },
  {
    city: "Melbourne - Melbourne Airport (Tullamarine)",
    country: "Australia",
    value: "MEL",
  },
  {
    city: "Melbourne (FL)",
    country: "USA",
    value: "MLB",
  },
  {
    city: "Melville Hall",
    country: "Dominica",
    value: "DOM",
  },
  {
    city: "Memphis (TN)",
    country: "USA",
    value: "MEM",
  },
  {
    city: "Mendoza",
    country: "Argentina",
    value: "MDZ",
  },
  {
    city: "Manado",
    country: "Indonesia",
    value: "MDC",
  },
  {
    city: "Merced (CA)",
    country: "USA",
    value: "MCE",
  },
  {
    city: "Merida",
    country: "Mexico",
    value: "MID",
  },
  {
    city: "Meridian (MS)",
    country: "USA",
    value: "MEI",
  },
  {
    city: "Merimbula",
    country: "Australia",
    value: "MIM",
  },
  {
    city: "Messina",
    country: "South Africa",
    value: "MEZ",
  },
  {
    city: "Metlakatla (AK)",
    country: "USA",
    value: "MTM",
  },
  {
    city: "Metz - Frescaty",
    country: "France",
    value: "MZM",
  },
  {
    city: "Metz/Nancy Metz-Nancy-Lorraine",
    country: "France",
    value: "ETZ",
  },
  {
    city: "Mexicali",
    country: "Mexico",
    value: "MXL",
  },
  {
    city: "Mexico city - Mexico city International Airport",
    country: "Mexico",
    value: "MEX",
  },
  {
    city: "Mexico city - Atizapan",
    country: "Mexico",
    value: "AZP",
  },
  {
    city: "Mexico city - Juarez International",
    country: "Mexico",
    value: "MEX",
  },
  {
    city: "Mexico city - Santa Lucia",
    country: "Mexico",
    value: "NLU",
  },
  {
    city: "Mfuwe",
    country: "Zambia",
    value: "MFU",
  },
  {
    city: "Miami (FL)",
    country: "USA",
    value: "MIA",
  },
  {
    city: "Mianwali",
    country: "Pakistan",
    value: "MWD",
  },
  {
    city: "Middlemount",
    country: "Australia",
    value: "MMM",
  },
  {
    city: "Midland/Odessa (TX)",
    country: "USA",
    value: "MAF",
  },
  {
    city: "Midway Island - Sand Island Field",
    country: "US Minor Outlying Islands",
    value: "MDY",
  },
  {
    city: "Mikkeli",
    country: "Finland",
    value: "MIK",
  },
  {
    city: "Milan",
    country: "Italy",
    value: "MIL",
  },
  {
    city: "Milan - Linate",
    country: "Italy",
    value: "LIN",
  },
  {
    city: "Milan - Malpensa",
    country: "Italy",
    value: "MXP",
  },
  {
    city: "Milan - Orio Al Serio",
    country: "Italy",
    value: "BGY",
  },
  {
    city: "Mildura",
    country: "Australia",
    value: "MQL",
  },
  {
    city: "Miles city (MT)",
    country: "USA",
    value: "MLS",
  },
  {
    city: "Milford Sound",
    country: "New Zealand",
    value: "MFN",
  },
  {
    city: "Milwaukee (WI)",
    country: "USA",
    value: "MKE",
  },
  {
    city: "Minatitlan",
    country: "Mexico",
    value: "MTT",
  },
  {
    city: "Mineralnye Vody",
    country: "Russia",
    value: "MRV",
  },
  {
    city: "Minneapolis - St. Paul International Airport (MN)",
    country: "USA",
    value: "MSP",
  },
  {
    city: "Minot (ND)",
    country: "USA",
    value: "MOT",
  },
  {
    city: "Minsk, International",
    country: "Belarus",
    value: "MSQ",
  },
  {
    city: "Miri",
    country: "Malaysia",
    value: "MYY",
  },
  {
    city: "Mirpur",
    country: "Pakistan",
    value: "QML",
  },
  {
    city: "Missula (MT)",
    country: "USA",
    value: "MSO",
  },
  {
    city: "Mitchell (SD)",
    country: "USA",
    value: "MHE",
  },
  {
    city: "Miyako Jima (Ryuku Islands) - Hirara",
    country: "Japan",
    value: "MMY",
  },
  {
    city: "Miyazaki",
    country: "Japan",
    value: "KMI",
  },
  {
    city: "Mkambati",
    country: "South Africa",
    value: "MBM",
  },
  {
    city: "Moanda",
    country: "Gabon",
    value: "MFF",
  },
  {
    city: "Mobile (AL) - Pascagoula (MS)",
    country: "USA",
    value: "MOB",
  },
  {
    city: "Modesto (CA)",
    country: "USA",
    value: "MOD",
  },
  {
    city: "Moenjodaro",
    country: "Pakistan",
    value: "MJD",
  },
  {
    city: "Mogadishu",
    country: "Somalia",
    value: "MGQ",
  },
  {
    city: "Mokuti",
    country: "Namibia",
    value: "OKU",
  },
  {
    city: "Moline/Quad Cities (IL)",
    country: "USA",
    value: "MLI",
  },
  {
    city: "Mombasa - Moi International",
    country: "Kenya",
    value: "MBA",
  },
  {
    city: "Monastir",
    country: "Tunisia",
    value: "MIR",
  },
  {
    city: "Moncton",
    country: "Canada",
    value: "YQM",
  },
  {
    city: "Monroe (LA)",
    country: "USA",
    value: "MLU",
  },
  {
    city: "Monrovia - Metropolitan Area",
    country: "Liberia",
    value: "MLW",
  },
  {
    city: "Monrovia - Roberts International",
    country: "Liberia",
    value: "ROB",
  },
  {
    city: "Montego Bay - Sangster International",
    country: "Jamaica",
    value: "MBJ",
  },
  {
    city: "Montenegro",
    country: "Brazil",
    value: "QGF",
  },
  {
    city: "Monterey (CA)",
    country: "USA",
    value: "MRY",
  },
  {
    city: "Monterrey - Gen. Mariano Escobedo",
    country: "Mexico",
    value: "MTY",
  },
  {
    city: "Monterrey - Aeropuerto Del Norte",
    country: "Mexico",
    value: "NTR",
  },
  {
    city: "Montevideo - Carrasco International Airport",
    country: "Uruguay",
    value: "MVD",
  },
  {
    city: "Montgomery (AL) - Montgomery Regional Airport",
    country: "USA",
    value: "MGM",
  },
  {
    city: "Montpellier - Montpellier–Méditerranée Airport",
    country: "France",
    value: "MPL",
  },
  {
    city: "Montreal",
    country: "Canada",
    value: "YMQ",
  },
  {
    city: "Montreal - Dorval (Montréal-Trudeau)",
    country: "Canada",
    value: "YUL",
  },
  {
    city: "Montreal - Mirabel",
    country: "Canada",
    value: "YMX",
  },
  {
    city: "Montrose/Tellruide (CO)",
    country: "USA",
    value: "MTJ",
  },
  {
    city: "Moorea",
    country: "French Polynesia",
    value: "MOZ",
  },
  {
    city: "Moranbah",
    country: "Australia",
    value: "MOV",
  },
  {
    city: "Moree",
    country: "Australia",
    value: "MRZ",
  },
  {
    city: "Morelia",
    country: "Mexico",
    value: "MLM",
  },
  {
    city: "Morgantown (WV)",
    country: "USA",
    value: "MGW",
  },
  {
    city: "Morioka, Hanamaki",
    country: "Japan",
    value: "HNA",
  },
  {
    city: "Moroni - Prince Said Ibrahim",
    country: "Comoros (Comores)",
    value: "HAH",
  },
  {
    city: "Moruya",
    country: "Australia",
    value: "MYA",
  },
  {
    city: "Moscow - Metropolitan Area",
    country: "Russia",
    value: "MOW",
  },
  {
    city: "Moscow - Domodedovo",
    country: "Russia",
    value: "DME",
  },
  {
    city: "Moscow - Sheremetyevo",
    country: "Russia",
    value: "SVO",
  },
  {
    city: "Moscow - Vnukovo",
    country: "Russia",
    value: "VKO",
  },
  {
    city: "Moses Lake (WA)",
    country: "USA",
    value: "MWH",
  },
  {
    city: "Mossel Bay",
    country: "South Africa",
    value: "MZY",
  },
  {
    city: "Mostar",
    country: "Bosnia and Herzegovina",
    value: "OMO",
  },
  {
    city: "Mosul",
    country: "Iraq",
    value: "OSM",
  },
  {
    city: "Mouila",
    country: "Gabon",
    value: "MJL",
  },
  {
    city: "Moundou",
    country: "Chad",
    value: "MQQ",
  },
  {
    city: "Mount Cook",
    country: "New Zealand",
    value: "GTN",
  },
  {
    city: "Mount Gambier",
    country: "Australia",
    value: "MGB",
  },
  {
    city: "Mount Magnet",
    country: "Australia",
    value: "MMG",
  },
  {
    city: "Mt. Isa",
    country: "Australia",
    value: "ISA",
  },
  {
    city: "Mt. McKinley (AK)",
    country: "USA",
    value: "MCL",
  },
  {
    city: "Muenchen (Munich) - Franz Josef Strauss",
    country: "Germany",
    value: "MUC",
  },
  {
    city: "Muenster/Osnabrueck",
    country: "Germany",
    value: "FMO",
  },
  {
    city: "Mulhouse",
    country: "France",
    value: "MLH",
  },
  {
    city: "Multan",
    country: "Pakistan",
    value: "MUX",
  },
  {
    city: "Murcia",
    country: "Spain",
    value: "MJV",
  },
  {
    city: "Murmansk",
    country: "Russia",
    value: "MMK",
  },
  {
    city: "Mus",
    country: "Turkey",
    value: "MSR",
  },
  {
    city: "Muscat - Seeb",
    country: "Oman",
    value: "MCT",
  },
  {
    city: "Muscle Shoals (AL)",
    country: "USA",
    value: "MSL",
  },
  {
    city: "Muskegon (MI)",
    country: "USA",
    value: "MKG",
  },
  {
    city: "Muzaffarabad",
    country: "Pakistan",
    value: "MFG",
  },
  {
    city: "Mvengue",
    country: "Gabon",
    value: "MVB",
  },
  {
    city: "Mykonos",
    country: "Greece",
    value: "JMK",
  },
  {
    city: "Myrtle Beach (SC) - Myrtle Beach AFB",
    country: "USA",
    value: "MYR",
  },
  {
    city: "Myrtle Beach (SC) - Grand Strand Airport",
    country: "USA",
    value: "CRE",
  },
  {
    city: "Mysore",
    country: "India",
    value: "MYQ",
  },
  {
    city: "Mytilene (Lesbos)",
    country: "Greece",
    value: "MJT",
  },
  {
    city: "Mzamba",
    country: "South Africa",
    value: "MZF",
  },
  {
    city: "Nadi",
    country: "Fiji",
    value: "NAN",
  },
  {
    city: "Nagasaki",
    country: "Japan",
    value: "NGS",
  },
  {
    city: "Nagoya - Komaki AFB",
    country: "Japan",
    value: "NGO",
  },
  {
    city: "Nagpur",
    country: "India",
    value: "NAG",
  },
  {
    city: "Nairobi",
    country: "Kenya",
    value: "NBO",
  },
  {
    city: "Nakhichevan",
    country: "Azerbaijan",
    value: "NAJ",
  },
  {
    city: "Nakhon Si Thammarat",
    country: "Thailand",
    value: "NST",
  },
  {
    city: "Nancy",
    country: "France",
    value: "ENC",
  },
  {
    city: "Nanisivik",
    country: "Canada",
    value: "YSR",
  },
  {
    city: "Nanning",
    country: "Guangxi, PR China",
    value: "NNG",
  },
  {
    city: "Nantes - Nantes Atlantique Airport",
    country: "France",
    value: "NTE",
  },
  {
    city: "Nantucket (MA)",
    country: "USA",
    value: "ACK",
  },
  {
    city: "Naples - Naples Capodichino Airport",
    country: "Italy",
    value: "NAP",
  },
  {
    city: "Naples (FL)",
    country: "USA",
    value: "APF",
  },
  {
    city: "Narrabri",
    country: "Australia",
    value: "NAA",
  },
  {
    city: "Narrandera",
    country: "Australia",
    value: "NRA",
  },
  {
    city: "Narsarsuaq",
    country: "Greenland",
    value: "UAK",
  },
  {
    city: "Nashville (TN)",
    country: "USA",
    value: "BNA",
  },
  {
    city: "Nassau",
    country: "Bahamas",
    value: "NAS",
  },
  {
    city: "Natal - Augusto Severo International Airport",
    country: "Brazil",
    value: "NAT",
  },
  {
    city: "Nausori",
    country: "Fiji/Suva",
    value: "SUV",
  },
  {
    city: "Nawab Shah",
    country: "Pakistan",
    value: "WNS",
  },
  {
    city: "Naxos - Naxos Airport",
    country: "Greece",
    value: "JNX",
  },
  {
    city: "N'Djamena",
    country: "Chad",
    value: "NDJ",
  },
  {
    city: "N'Dola",
    country: "Zambia",
    value: "NLA",
  },
  {
    city: "Nelson",
    country: "New Zealand",
    value: "NSN",
  },
  {
    city: "Nelspruit",
    country: "South Africa",
    value: "NLP",
  },
  {
    city: "Nelspruit - Kruger Mpumalanga International Airport",
    country: "South Africa",
    value: "MQP",
  },
  {
    city: "Nevis",
    country: "St. Kitts and Nevis",
    value: "NEV",
  },
  {
    city: "New Bern (NC)",
    country: "USA",
    value: "EWN",
  },
  {
    city: "New Haven (CT)",
    country: "USA",
    value: "HVN",
  },
  {
    city: "New Orleans, La",
    country: "USA",
    value: "MSY",
  },
  {
    city: "Newquay",
    country: "United Kingdom",
    value: "NQY",
  },
  {
    city: "New Valley - Kharga",
    country: "Egypt",
    value: "UVL",
  },
  {
    city: "New York - John F. Kennedy (NY)",
    country: "USA",
    value: "JFK",
  },
  {
    city: "New York - LaGuardia (NY)",
    country: "USA",
    value: "LGA",
  },
  {
    city: "New York - Newark (NJ)",
    country: "USA",
    value: "EWR",
  },
  {
    city: "New York (NY)",
    country: "USA",
    value: "NYC",
  },
  {
    city: "Newburgh (NY)",
    country: "USA",
    value: "SWF",
  },
  {
    city: "Newcastle - Belmont",
    country: "Australia",
    value: "BEO",
  },
  {
    city: "Newcastle - Williamtown",
    country: "Australia",
    value: "NTL",
  },
  {
    city: "Newcastle",
    country: "United Kingdom",
    value: "NCL",
  },
  {
    city: "Newcastle",
    country: "South Africa",
    value: "NCS",
  },
  {
    city: "Newman",
    country: "Australia",
    value: "ZNE",
  },
  {
    city: "Newport News/Williamsburg (VA)",
    country: "USA",
    value: "PHF",
  },
  {
    city: "N'Gaoundere",
    country: "Cameroon",
    value: "NGE",
  },
  {
    city: "Niagara Falls International",
    country: "USA",
    value: "IAG",
  },
  {
    city: "Niamey",
    country: "Niger",
    value: "NIM",
  },
  {
    city: "Nice - Cote D'Azur Airport",
    country: "France",
    value: "NCE",
  },
  {
    city: "Nicosia",
    country: "Cyprus",
    value: "NIC",
  },
  {
    city: "Nikolaev",
    country: "Ukraine",
    value: "NLV",
  },
  {
    city: "Niigata",
    country: "Japan",
    value: "KIJ",
  },
  {
    city: "Nimes",
    country: "France",
    value: "FNI",
  },
  {
    city: "Nis",
    country: "Serbia",
    value: "INI",
  },
  {
    city: "Nizhny Novgorod - Strigino International Airport",
    country: "Russia",
    value: "GOJ",
  },
  {
    city: "Nome (AK)",
    country: "USA",
    value: "OME",
  },
  {
    city: "Noosa",
    country: "Australia",
    value: "NSA",
  },
  {
    city: "Norfolk Island",
    country: "Australia",
    value: "NLK",
  },
  {
    city: "Norfolk/Virginia Beach (VA)",
    country: "USA",
    value: "ORF",
  },
  {
    city: "Norman Wells",
    country: "Canada",
    value: "YVQ",
  },
  {
    city: "Norrkoeping",
    country: "Sweden",
    value: "NRK",
  },
  {
    city: "North Bend (OR)",
    country: "USA",
    value: "OTH",
  },
  {
    city: "North Eleuthera",
    country: "Bahamas",
    value: "ELH",
  },
  {
    city: "Norwich",
    country: "United Kingdom",
    value: "NWI",
  },
  {
    city: "Nottingham - East Midlands",
    country: "United Kingdom",
    value: "EMA",
  },
  {
    city: "Nouadhibou",
    country: "Mauritania",
    value: "NDB",
  },
  {
    city: "Nouakchott",
    country: "Mauritania",
    value: "NKC",
  },
  {
    city: "Noumea",
    country: "New Caledonia",
    value: "NOU",
  },
  {
    city: "Novi Sad",
    country: "Serbia",
    value: "QND",
  },
  {
    city: "Novosibirsk - Tolmachevo Airport",
    country: "Russia",
    value: "OVB",
  },
  {
    city: "Nürnberg (Nuremberg)",
    country: "Germany",
    value: "NUE",
  },
  {
    city: "Nuevo Laredo",
    country: "Mexico",
    value: "NLD",
  },
  {
    city: "Nuku'alofa - Fua'Amotu International",
    country: "Tonga",
    value: "TBU",
  },
  {
    city: "Oakland (CA)",
    country: "USA",
    value: "OAK",
  },
  {
    city: "Oaxaca - Xoxocotlan",
    country: "Mexico",
    value: "OAX",
  },
  {
    city: "Odense",
    country: "Denmark",
    value: "ODE",
  },
  {
    city: "Odessa",
    country: "Ukraine",
    value: "ODS",
  },
  {
    city: "Oerebro",
    country: "Sweden",
    value: "ORB",
  },
  {
    city: "Ohrid",
    country: "Macedonia",
    value: "OHD",
  },
  {
    city: "Oita",
    country: "Japan",
    value: "OIT",
  },
  {
    city: "Okayama",
    country: "Japan",
    value: "OKJ",
  },
  {
    city: "Okinawa, Ryukyo Island - Naha",
    country: "Japan",
    value: "OKA",
  },
  {
    city: "Oklahoma city (OK) - Will Rogers World",
    country: "USA",
    value: "OKC",
  },
  {
    city: "Olbia",
    country: "Italy",
    value: "OLB",
  },
  {
    city: "Olympic Dam",
    country: "Australia",
    value: "OLP",
  },
  {
    city: "Omaha (NE)",
    country: "USA",
    value: "OMA",
  },
  {
    city: "Ondangwa",
    country: "Namibia",
    value: "OND",
  },
  {
    city: "Ontario (CA)",
    country: "USA",
    value: "ONT",
  },
  {
    city: "Oran (Ouahran)",
    country: "Algeria",
    value: "ORN",
  },
  {
    city: "Orange",
    country: "Australia",
    value: "OAG",
  },
  {
    city: "Orange County (Santa Ana) (CA)",
    country: "USA",
    value: "SNA",
  },
  {
    city: "Oranjemund",
    country: "Namibia",
    value: "OMD",
  },
  {
    city: "Oranjestad - Reina Beatrix International",
    country: "Aruba",
    value: "AUA",
  },
  {
    city: "Orkney - Kirkwall",
    country: "United Kingdom",
    value: "KOI",
  },
  {
    city: "Orlando Metropolitan Area (FL)",
    country: "USA",
    value: "ORL",
  },
  {
    city: "Orlando - International Airport (FL)",
    country: "USA",
    value: "MCO",
  },
  {
    city: "Orpheus Island",
    country: "Australia",
    value: "ORS",
  },
  {
    city: "Osaka, Metropolitan Area",
    country: "Japan",
    value: "OSA",
  },
  {
    city: "Osaka - Itami",
    country: "Japan",
    value: "ITM",
  },
  {
    city: "Osaka - Kansai International Airport",
    country: "Japan",
    value: "KIX",
  },
  {
    city: "Oshkosh (WI)",
    country: "USA",
    value: "OSH",
  },
  {
    city: "Osijek",
    country: "Croatia (Hrvatska)",
    value: "OSI",
  },
  {
    city: "Oslo - Oslo Airport, Gardermoen",
    country: "Norway",
    value: "OSL",
  },
  {
    city: "Oslo - Fornebu",
    country: "Norway",
    value: "FBU",
  },
  {
    city: "Oslo - Sandefjord",
    country: "Norway",
    value: "TRF",
  },
  {
    city: "Ottawa - Hull",
    country: "Canada",
    value: "YOW",
  },
  {
    city: "Ouadda",
    country: "Central African Republic",
    value: "ODA",
  },
  {
    city: "Ouarzazate",
    country: "Morocco",
    value: "OZZ",
  },
  {
    city: "Oudtshoorn",
    country: "South Africa",
    value: "OUH",
  },
  {
    city: "Ouagadougou",
    country: "Burkina Faso",
    value: "OUA",
  },
  {
    city: "Oujda",
    country: "Morocco",
    value: "OUD",
  },
  {
    city: "Oulu",
    country: "Finland",
    value: "OUL",
  },
  {
    city: "Out Skerries (Shetland)",
    country: "United Kingdom",
    value: "OUK",
  },
  {
    city: "Oviedo",
    country: "Spain",
    value: "OVD",
  },
  {
    city: "Owensboro (KY)",
    country: "USA",
    value: "OWB",
  },
  {
    city: "Oxnard (CA)",
    country: "USA",
    value: "OXR",
  },
  {
    city: "Oyem",
    country: "Gabon/Loyautte",
    value: "UVE",
  },
  {
    city: "Paderborn/Lippstadt",
    country: "Germany",
    value: "PAD",
  },
  {
    city: "Paducah (KY)",
    country: "USA",
    value: "PAH",
  },
  {
    city: "Page/Lake Powell (AZ)",
    country: "USA",
    value: "PGA",
  },
  {
    city: "Pago Pago",
    country: "American Samoa",
    value: "PPG",
  },
  {
    city: "Pakersburg (WV) /Marietta (OH)",
    country: "USA",
    value: "PKB",
  },
  {
    city: "Palermo - Punta Raisi",
    country: "Italy",
    value: "PMO",
  },
  {
    city: "Palma de Mallorca",
    country: "Spain",
    value: "PMI",
  },
  {
    city: "Palmas",
    country: "Brazil",
    value: "PMW",
  },
  {
    city: "Palmdale/Lancaster (CA)",
    country: "USA",
    value: "PMD",
  },
  {
    city: "Palmerston North",
    country: "New Zealand",
    value: "PMR",
  },
  {
    city: "Palm Springs (CA)",
    country: "USA",
    value: "PSP",
  },
  {
    city: "Panama city - Tocumen International",
    country: "Panama",
    value: "PTY",
  },
  {
    city: "Panama city (FL)",
    country: "USA",
    value: "PFN",
  },
  {
    city: "Panjgur",
    country: "Pakistan",
    value: "PJG",
  },
  {
    city: "Pantelleria",
    country: "Italy",
    value: "PNL",
  },
  {
    city: "Papeete - Faaa",
    country: "French Polynesia (Tahiti)",
    value: "PPT",
  },
  {
    city: "Paphos",
    country: "Cyprus",
    value: "PFO",
  },
  {
    city: "Paraburdoo",
    country: "Australia",
    value: "PBO",
  },
  {
    city: "Paramaribo - Zanderij International",
    country: "Suriname",
    value: "PBM",
  },
  {
    city: "Paris",
    country: "France",
    value: "PAR",
  },
  {
    city: "Paris - Charles de Gaulle",
    country: "France",
    value: "CDG",
  },
  {
    city: "Paris - Le Bourget",
    country: "France",
    value: "LBG",
  },
  {
    city: "Paris - Orly",
    country: "France",
    value: "ORY",
  },
  {
    city: "Paro",
    country: "Bhutan",
    value: "PBH",
  },
  {
    city: "Pasco (WA)",
    country: "USA",
    value: "PSC",
  },
  {
    city: "Pasni",
    country: "Pakistan",
    value: "PSI",
  },
  {
    city: "Patna",
    country: "India",
    value: "PAT",
  },
  {
    city: "Pattaya",
    country: "Thailand",
    value: "PYX",
  },
  {
    city: "Pau",
    country: "France",
    value: "PUF",
  },
  {
    city: "Pellston (MI)",
    country: "USA",
    value: "PLN",
  },
  {
    city: "Penang International",
    country: "Malaysia",
    value: "PEN",
  },
  {
    city: "Pendelton (OR)",
    country: "USA",
    value: "PDT",
  },
  {
    city: "Pensacola (FL)",
    country: "USA",
    value: "PNS",
  },
  {
    city: "Peoria/Bloomington (IL)",
    country: "USA",
    value: "PIA",
  },
  {
    city: "Pereira",
    country: "Colombia",
    value: "PEI",
  },
  {
    city: "Perpignan",
    country: "France",
    value: "PGF",
  },
  {
    city: "Perth International",
    country: "Australia",
    value: "PER",
  },
  {
    city: "Perugia",
    country: "Italy",
    value: "PEG",
  },
  {
    city: "Pescara",
    country: "Italy",
    value: "PSR",
  },
  {
    city: "Peshawar",
    country: "Pakistan",
    value: "PEW",
  },
  {
    city: "Petersburg (AK)",
    country: "USA",
    value: "PSG",
  },
  {
    city: "Phalaborwa",
    country: "South Africa",
    value: "PHW",
  },
  {
    city: "Philadelphia (PA) - International",
    country: "USA",
    value: "PHL",
  },
  {
    city: "Phnom Penh - Pochentong",
    country: "Cambodia",
    value: "PNH",
  },
  {
    city: "Phoenix (AZ) - Sky Harbor International",
    country: "USA",
    value: "PHX",
  },
  {
    city: "Phuket",
    country: "Thailand",
    value: "HKT",
  },
  {
    city: "Pierre (SD)",
    country: "USA",
    value: "PIR",
  },
  {
    city: "Pietermaritzburg",
    country: "South Africa",
    value: "PZB",
  },
  {
    city: "Pietersburg",
    country: "South Africa",
    value: "PTG",
  },
  {
    city: "Pilanesberg/Sun city",
    country: "South Africa",
    value: "NTY",
  },
  {
    city: "Pisa - Galileo Galilei",
    country: "Italy",
    value: "PSA",
  },
  {
    city: "Pittsburgh International Airport (PA)",
    country: "USA",
    value: "PIT",
  },
  {
    city: "Plattsburgh (NY)",
    country: "USA",
    value: "PLB",
  },
  {
    city: "Plettenberg Bay",
    country: "South Africa",
    value: "PBZ",
  },
  {
    city: "Pocatello (ID)",
    country: "USA",
    value: "PIH",
  },
  {
    city: "Podgorica",
    country: "Montenegro",
    value: "TGD",
  },
  {
    city: "Pohnpei",
    country: "Micronesia",
    value: "PNI",
  },
  {
    city: "Pointe a Pitre",
    country: "Guadeloupe",
    value: "PTP",
  },
  {
    city: "Pointe Noire",
    country: "Congo (ROC)",
    value: "PNR",
  },
  {
    city: "Poitiers - Biard",
    country: "France",
    value: "PIS",
  },
  {
    city: "Ponce",
    country: "Puerto Rico",
    value: "PSE",
  },
  {
    city: "Ponta Delgada",
    country: "Portugal",
    value: "PDL",
  },
  {
    city: "Pori",
    country: "Finland",
    value: "POR",
  },
  {
    city: "Port Angeles (WA)",
    country: "USA",
    value: "CLM",
  },
  {
    city: "Port au Prince",
    country: "Haiti",
    value: "PAP",
  },
  {
    city: "Port Augusta",
    country: "Australia",
    value: "PUG",
  },
  {
    city: "Port Elizabeth",
    country: "South Africa",
    value: "PLZ",
  },
  {
    city: "Port Gentil",
    country: "Gabon",
    value: "POG",
  },
  {
    city: "Port Harcourt",
    country: "Nigeria",
    value: "PHC",
  },
  {
    city: "Port Hedland",
    country: "Australia",
    value: "PHE",
  },
  {
    city: "Portland",
    country: "Australia",
    value: "PTJ",
  },
  {
    city: "Portland (ME)",
    country: "USA",
    value: "PWM",
  },
  {
    city: "Portland International (OR)",
    country: "USA",
    value: "PDX",
  },
  {
    city: "Port Lincoln",
    country: "Australia",
    value: "PLO",
  },
  {
    city: "Port Macquarie",
    country: "Australia",
    value: "PQQ",
  },
  {
    city: "Port Menier, PQ",
    country: "Canada",
    value: "YPN",
  },
  {
    city: "Port Moresby - Jackson Field",
    country: "Papua New Guinea",
    value: "POM",
  },
  {
    city: "Porto",
    country: "Portugal",
    value: "OPO",
  },
  {
    city: "Porto Alegre - Salgado Filho International Airport",
    country: "Brazil",
    value: "POA",
  },
  {
    city: "Port of Spain - Piarco International",
    country: "Trinidad and Tobago",
    value: "POS",
  },
  {
    city: "Port Said",
    country: "Egypt",
    value: "PSD",
  },
  {
    city: "Porto Santo",
    country: "Portugal",
    value: "PXO",
  },
  {
    city: "Porto Velho",
    country: "Brazil",
    value: "PVH",
  },
  {
    city: "Port Vila",
    country: "Vanuatu",
    value: "VLI",
  },
  {
    city: "Poughkeepsie (NY)",
    country: "USA",
    value: "POU",
  },
  {
    city: "Poznan, Lawica",
    country: "Poland",
    value: "POZ",
  },
  {
    city: "Prague - Václav Havel Airport (formerly Ruzyne)",
    country: "Czech Republic",
    value: "PRG",
  },
  {
    city: "Praia - Nelson Mandela International Airport",
    country: "Cape Verde",
    value: "RAI",
  },
  {
    city: "Presque Island (ME)",
    country: "USA",
    value: "PQI",
  },
  {
    city: "Pretoria - Wonderboom Apt.",
    country: "South Africa",
    value: "PRY",
  },
  {
    city: "Preveza/Lefkas",
    country: "Greece",
    value: "PVK",
  },
  {
    city: "Prince George",
    country: "Canada",
    value: "YXS",
  },
  {
    city: "Prince Rupert/Digby Island",
    country: "Canada",
    value: "YPR",
  },
  {
    city: "Pristina",
    country: "Serbia",
    value: "PRN",
  },
  {
    city: "Prosperpine",
    country: "Australia",
    value: "PPP",
  },
  {
    city: "Providence (RI)",
    country: "USA",
    value: "PVD",
  },
  {
    city: "Prudhoe Bay (AK)",
    country: "USA",
    value: "SCC",
  },
  {
    city: "Puebla",
    country: "Mexico",
    value: "PBC",
  },
  {
    city: "Pueblo (CO)",
    country: "USA",
    value: "PUB",
  },
  {
    city: "Puerto Escondido",
    country: "Mexico",
    value: "PXM",
  },
  {
    city: "Puerto Ordaz",
    country: "Venezuela",
    value: "PZO",
  },
  {
    city: "Puerto Plata",
    country: "Dominican Republic",
    value: "POP",
  },
  {
    city: "Puerto Vallarta",
    country: "Mexico",
    value: "PVR",
  },
  {
    city: "Pukatawagan",
    country: "Canada",
    value: "XPK",
  },
  {
    city: "Pula",
    country: "Croatia (Hrvatska)",
    value: "PUY",
  },
  {
    city: "Pullman (WA)",
    country: "USA",
    value: "PUW",
  },
  {
    city: "Pune",
    country: "India, Maharashtra",
    value: "PNQ",
  },
  {
    city: "Punta Arenas - Presidente Carlos Ibáñez del Campo",
    country: "Chile",
    value: "PUQ",
  },
  {
    city: "Punta Cana - Punta Cana International",
    country: "Dominican Republic",
    value: "PUJ",
  },
  {
    city: "Pu San (Busan) - Gimhae International Airport",
    country: "South Korea",
    value: "PUS",
  },
  {
    city: "Pyongyang - Sunan International Airport",
    country: "North Korea",
    value: "FNJ",
  },
  {
    city: "Quebec - Quebec International",
    country: "Canada",
    value: "YQB",
  },
  {
    city: "Queenstown",
    country: "Australia",
    value: "UEE",
  },
  {
    city: "Queenstown",
    country: "New Zealand",
    value: "ZQN",
  },
  {
    city: "Quetta",
    country: "Pakistan",
    value: "UET",
  },
  {
    city: "Qingdao",
    country: "Shandong, PR China",
    value: "TAO",
  },
  {
    city: "Quimper",
    country: "France",
    value: "UIP",
  },
  {
    city: "Quincy (IL)",
    country: "USA",
    value: "UIN",
  },
  {
    city: "Quito - Mariscal Sucre International Airport",
    country: "Ecuador",
    value: "UIO",
  },
  {
    city: "Rabat - Rabat-Salé Airport",
    country: "Morocco",
    value: "RBA",
  },
  {
    city: "Rahim Yar Khan - Shaikh Zayed International Airport",
    country: "Pakistan",
    value: "RYK",
  },
  {
    city: "Raiatea",
    country: "French Polynesia",
    value: "RFP",
  },
  {
    city: "Rainbow Lake, AB",
    country: "Canada",
    value: "YOP",
  },
  {
    city: "Rajkot",
    country: "India",
    value: "RAJ",
  },
  {
    city: "Raleigh/Durham (NC)",
    country: "USA",
    value: "RDU",
  },
  {
    city: "Ranchi",
    country: "India",
    value: "IXR",
  },
  {
    city: "Rangiroa",
    country: "French Polynesia",
    value: "RGI",
  },
  {
    city: "Rangoon (Yangon) - Mingaladon",
    country: "Myanmar",
    value: "RGN",
  },
  {
    city: "Rapid city (SD)",
    country: "USA",
    value: "RAP",
  },
  {
    city: "Rarotonga",
    country: "Cook Island",
    value: "RAR",
  },
  {
    city: "Ras al Khaymah (Ras al Khaimah)",
    country: "United Arab Emirates",
    value: "RKT",
  },
  {
    city: "Rawala Kot",
    country: "Pakistan",
    value: "RAZ",
  },
  {
    city: "Rawalpindi",
    country: "Pakistan",
    value: "RWP",
  },
  {
    city: "Reading (PA)",
    country: "USA",
    value: "RDG",
  },
  {
    city: "Recife - Guararapes-Gilberto Freyre International",
    country: "Brazil",
    value: "REC",
  },
  {
    city: "Redding (CA)",
    country: "USA",
    value: "RDD",
  },
  {
    city: "Redmond (OR)",
    country: "USA",
    value: "RDM",
  },
  {
    city: "Reggio Calabria",
    country: "Italy",
    value: "REG",
  },
  {
    city: "Regina",
    country: "Canada",
    value: "YQR",
  },
  {
    city: "Reina Sofia",
    country: "Teneriffa/Spain",
    value: "TFS",
  },
  {
    city: "Rennes",
    country: "France",
    value: "RNS",
  },
  {
    city: "Reno (NV)",
    country: "USA",
    value: "RNO",
  },
  {
    city: "Resolute Bay",
    country: "Canada",
    value: "YRB",
  },
  {
    city: "Reus",
    country: "Spain",
    value: "REU",
  },
  {
    city: "Reykjavik - Metropolitan Area",
    country: "Iceland",
    value: "REK",
  },
  {
    city: "Reykjavik - Keflavik International",
    country: "Iceland",
    value: "KEF",
  },
  {
    city: "Rhinelander (WI)",
    country: "USA",
    value: "RHI",
  },
  {
    city: "Rhodos",
    country: "Greece",
    value: "RHO",
  },
  {
    city: "Richards Bay",
    country: "South Africa",
    value: "RCB",
  },
  {
    city: "Richmond (VA)",
    country: "USA",
    value: "RIC",
  },
  {
    city: "Riga",
    country: "Latvia",
    value: "RIX",
  },
  {
    city: "Rijeka",
    country: "Croatia (Hrvatska)",
    value: "RJK",
  },
  {
    city: "Rimini",
    country: "Italy",
    value: "RMI",
  },
  {
    city: "Rio Branco - Plácido de Castro International Airport",
    country: "Brazil",
    value: "RBR",
  },
  {
    city: "Rio de Janeiro - Galeao",
    country: "Brazil",
    value: "GIG",
  },
  {
    city: "Rio de Janeiro - Santos Dumont",
    country: "Brazil",
    value: "SDU",
  },
  {
    city: "Rio de Janeiro",
    country: "Brazil",
    value: "RIO",
  },
  {
    city: "Riyadh - King Khaled International",
    country: "Saudi Arabia",
    value: "RUH",
  },
  {
    city: "Roanne",
    country: "France",
    value: "RNE",
  },
  {
    city: "Roanoke (VA)",
    country: "USA",
    value: "ROA",
  },
  {
    city: "Roatan",
    country: "Honduras",
    value: "RTB",
  },
  {
    city: "Rochester (MN)",
    country: "USA",
    value: "RST",
  },
  {
    city: "Rochester (NY)",
    country: "USA",
    value: "ROC",
  },
  {
    city: "Rock Sound",
    country: "Bahamas",
    value: "RSD",
  },
  {
    city: "Rock Springs (WY)",
    country: "USA",
    value: "RKS",
  },
  {
    city: "Rockford (IL)",
    country: "USA",
    value: "RFD",
  },
  {
    city: "Rockhampton",
    country: "Australia",
    value: "ROK",
  },
  {
    city: "Rockland (ME)",
    country: "USA",
    value: "RKD",
  },
  {
    city: "Rocky Mount - Wilson (NC)",
    country: "USA",
    value: "RWI",
  },
  {
    city: "Rodez",
    country: "France",
    value: "RDZ",
  },
  {
    city: "Rodrigues Island",
    country: "Mauritius",
    value: "RRG",
  },
  {
    city: "Roenne",
    country: "Denmark",
    value: "RNN",
  },
  {
    city: "Rome",
    country: "Italy",
    value: "ROM",
  },
  {
    city: "Rome - Ciampino",
    country: "Italy",
    value: "CIA",
  },
  {
    city: "Rome - Fuimicino",
    country: "Italy",
    value: "FCO",
  },
  {
    city: "Ronneby",
    country: "Sweden",
    value: "RNB",
  },
  {
    city: "Rosario",
    country: "Argentina",
    value: "ROS",
  },
  {
    city: "Rostov-on-Don - Rostov-on-Don Airport",
    country: "Russia",
    value: "RVI",
  },
  {
    city: "Rostov-on-Don - Platov International Airport",
    country: "Russia",
    value: "ROV",
  },
  {
    city: "Rotorua",
    country: "New Zealand",
    value: "ROT",
  },
  {
    city: "Rotterdam",
    country: "Netherlands",
    value: "RTM",
  },
  {
    city: "Rovaniemi",
    country: "Finland",
    value: "RVN",
  },
  {
    city: "Rundu",
    country: "Namibia",
    value: "NDU",
  },
  {
    city: "Ruse",
    country: "Bulgaria",
    value: "ROU",
  },
  {
    city: "Saarbruecken",
    country: "Germany",
    value: "SCN",
  },
  {
    city: "Sacramento (CA)",
    country: "USA",
    value: "SMF",
  },
  {
    city: "Sado Shima",
    country: "Japan",
    value: "SDS",
  },
  {
    city: "Saginaw/Bay city/Midland (MI)",
    country: "USA",
    value: "MBS",
  },
  {
    city: "Saidu Sharif",
    country: "Pakistan",
    value: "SDT",
  },
  {
    city: "Saigon (Ho Chi Minh city) - Tan Son Nhat International",
    country: "Viet Nam",
    value: "SGN",
  },
  {
    city: "Saint Brieuc",
    country: "France",
    value: "SBK",
  },
  {
    city: "Saint Denis - Roland Garros Airport",
    country: "Reunion",
    value: "RUN",
  },
  {
    city: "Saint John",
    country: "Canada",
    value: "YSJ",
  },
  {
    city: "Saipan",
    country: "Northern Mariana Islands",
    value: "SPN",
  },
  {
    city: "Sal",
    country: "Cape Verde",
    value: "SID",
  },
  {
    city: "Salalah",
    country: "Oman",
    value: "SLL",
  },
  {
    city: "Salem (OR)",
    country: "USA",
    value: "SLE",
  },
  {
    city: "Salinas (CA)",
    country: "USA",
    value: "SNS",
  },
  {
    city: "Salinas",
    country: "Ecuador",
    value: "SNC",
  },
  {
    city: "Salisbury",
    country: "Zimbabwe",
    value: "SAY",
  },
  {
    city: "Salisbury (MD)",
    country: "USA",
    value: "SBY",
  },
  {
    city: "Saloniki",
    country: "Greece",
    value: "SKG",
  },
  {
    city: "Salta, Gen Belgrano",
    country: "Argentina",
    value: "SLA",
  },
  {
    city: "Salt Lake city (UT)",
    country: "USA",
    value: "SLC",
  },
  {
    city: "Salvador - Salvador International Airport",
    country: "Brazil",
    value: "SSA",
  },
  {
    city: "Salzburg - W.A. Mozart",
    country: "Austria",
    value: "SZG",
  },
  {
    city: "Samara - Kurumoch International Airport",
    country: "Russia",
    value: "KUF",
  },
  {
    city: "Samarkand - Samarkand International Airport",
    country: "Uzbekistan",
    value: "SKD",
  },
  {
    city: "Samos",
    country: "Greece",
    value: "SMI",
  },
  {
    city: "Samsun",
    country: "Turkey",
    value: "SZF",
  },
  {
    city: "San Andres",
    country: "Colombia",
    value: "ADZ",
  },
  {
    city: "San Angelo (TX)",
    country: "USA",
    value: "SJT",
  },
  {
    city: "San Antonio (TX)",
    country: "USA",
    value: "SAT",
  },
  {
    city: "San Carlos de Bariloche",
    country: "Argentina",
    value: "BRC",
  },
  {
    city: "San Diego - Lindberg Field International (CA)",
    country: "USA",
    value: "SAN",
  },
  {
    city: "San Francisco - International Airport, SA",
    country: "USA",
    value: "SFO",
  },
  {
    city: "San Jose Cabo",
    country: "Mexico",
    value: "SJD",
  },
  {
    city: "San Jose",
    country: "Costa Rica",
    value: "SJO",
  },
  {
    city: "San Jose (CA)",
    country: "USA",
    value: "SJC",
  },
  {
    city: "San Juan - Luis Munoz Marin International Airport",
    country: "Puerto Rico",
    value: "SJU",
  },
  {
    city: "San Luis Obisco (CA)",
    country: "USA",
    value: "SBP",
  },
  {
    city: "San Luis Potosi",
    country: "Mexico",
    value: "SLP",
  },
  {
    city: "San Pedro",
    country: "Cote d'Ivoire",
    value: "SPY",
  },
  {
    city: "San Pedro Sula",
    country: "Honduras",
    value: "SAP",
  },
  {
    city: "San Salvador",
    country: "Bahamas",
    value: "ZSA",
  },
  {
    city: "San Salvador",
    country: "El Salvador",
    value: "SAL",
  },
  {
    city: "San Sebastian",
    country: "Spain",
    value: "EAS",
  },
  {
    city: "Sanaa (Sana'a) - Sana'a International",
    country: "Yemen",
    value: "SAH",
  },
  {
    city: "Sandspit",
    country: "Canada",
    value: "YZP",
  },
  {
    city: "Santa Ana - John Wayne Airport (CA)",
    country: "USA",
    value: "SNA",
  },
  {
    city: "Santa Barbara (CA)",
    country: "USA",
    value: "SBA",
  },
  {
    city: "Santa Cruz de la Palma",
    country: "Spain",
    value: "SPC",
  },
  {
    city: "Santa Cruz de la Sierra",
    country: "Bolivia",
    value: "SRZ",
  },
  {
    city: "Santa Katarina - Mount Sinai",
    country: "Egypt",
    value: "SKV",
  },
  {
    city: "Santa Maria",
    country: "Portugal",
    value: "SMA",
  },
  {
    city: "Santa Maria (CA)",
    country: "USA",
    value: "SMX",
  },
  {
    city: "Santander",
    country: "Spain",
    value: "SDR",
  },
  {
    city: "Santa Rosa (CA)",
    country: "USA",
    value: "STS",
  },
  {
    city: "Santa Rosa",
    country: "Bolivia",
    value: "SRB",
  },
  {
    city: "Santa Rosa",
    country: "Brazil",
    value: "SRA",
  },
  {
    city: "Santa Rosa",
    country: "Argentina",
    value: "RSA",
  },
  {
    city: "Santa Rosa, Copan",
    country: "Honduras",
    value: "SDH",
  },
  {
    city: "Santa Rosalia",
    country: "Colombia",
    value: "SSL",
  },
  {
    city: "Santa Rosalia",
    country: "Mexico",
    value: "SRL",
  },
  {
    city: "Santiago - Antonio Maceo Airport",
    country: "Cuba",
    value: "SCU",
  },
  {
    city: "Santiago de Chile - Arturo Merino Benitez",
    country: "Chile",
    value: "SCL",
  },
  {
    city: "Santiago de Compostela",
    country: "Spain",
    value: "SCQ",
  },
  {
    city: "Santo",
    country: "Vanuatu",
    value: "SON",
  },
  {
    city: "Santo Domingo",
    country: "Dominican Republic",
    value: "SDQ",
  },
  {
    city: "Sao Luis - Marechal Cunha Machado International",
    country: "Brazil",
    value: "SLZ",
  },
  {
    city: "Sao Paulo",
    country: "Brazil",
    value: "SAO",
  },
  {
    city: "Sao Paulo - Congonhas",
    country: "Brazil",
    value: "CGH",
  },
  {
    city: "Sao Paulo - Guarulhos",
    country: "Brazil",
    value: "GRU",
  },
  {
    city: "Sao Paulo - Viracopos",
    country: "Brazil",
    value: "VCP",
  },
  {
    city: "Sao Tome",
    country: "Sao Tome & Principe",
    value: "TMS",
  },
  {
    city: "Sapporo",
    country: "Hokkaido, Japan",
    value: "SPK",
  },
  {
    city: "Sapporo - Okadama",
    country: "Hokkaido, Japan",
    value: "OKD",
  },
  {
    city: "Sapporo - New Chitose Airport",
    country: "Japan",
    value: "CTS",
  },
  {
    city: "Sarajevo",
    country: "Bosnia and Herzegovina",
    value: "SJJ",
  },
  {
    city: "Saransk - Saransk Airport",
    country: "Russia",
    value: "SKX",
  },
  {
    city: "Sarasota/Bradenton (FL)",
    country: "USA",
    value: "SRQ",
  },
  {
    city: "Saskatoon",
    country: "Canada",
    value: "YXE",
  },
  {
    city: "Sassandra",
    country: "Cote d'Ivoire",
    value: "ZSS",
  },
  {
    city: "Savannah (GA)",
    country: "USA",
    value: "SAV",
  },
  {
    city: "Savonlinna",
    country: "Finland",
    value: "SVL",
  },
  {
    city: "Scarborough - Crown Point International",
    country: "Trinidad and Tobago",
    value: "TAB",
  },
  {
    city: "Scone",
    country: "Australia",
    value: "NSO",
  },
  {
    city: "Scottsdale (AZ)",
    country: "USA",
    value: "SCF",
  },
  {
    city: "Seattle/Tacoma (WA)",
    country: "USA",
    value: "SEA",
  },
  {
    city: "Sehba",
    country: "Libya",
    value: "SEB",
  },
  {
    city: "Seinaejoki",
    country: "Finland",
    value: "SJY",
  },
  {
    city: "Selibi Phikwe",
    country: "Botswana",
    value: "PKW",
  },
  {
    city: "Sendai",
    country: "Japan",
    value: "SDJ",
  },
  {
    city: "Seoul - Incheon International Airport",
    country: "South Korea",
    value: "ICN",
  },
  {
    city: "Seoul - Kimpo",
    country: "South Korea",
    value: "SEL",
  },
  {
    city: "Sevilla",
    country: "Spain",
    value: "SVQ",
  },
  {
    city: "Sfax",
    country: "Tunisia",
    value: "SFA",
  },
  {
    city: "Shamattawa, MB",
    country: "Canada",
    value: "ZTM",
  },
  {
    city: "Shanghai - Hongqiao",
    country: "China",
    value: "SHA",
  },
  {
    city: "Shanghai - Pu Dong",
    country: "China",
    value: "PVG",
  },
  {
    city: "Shannon (Limerick)",
    country: "Ireland",
    value: "SNN",
  },
  {
    city: "Sharjah",
    country: "United Arab Emirates",
    value: "SHJ",
  },
  {
    city: "Sharm El Sheikh",
    country: "Egypt",
    value: "SSH",
  },
  {
    city: "Sheffield, city Airport",
    country: "United Kingdom",
    value: "SZD",
  },
  {
    city: "Sheffield, Doncaster, Robin Hood International Airport",
    country: "United Kingdom",
    value: "DSA",
  },
  {
    city: "Shenandoah Valley/Stauton (VA)",
    country: "USA",
    value: "SHD",
  },
  {
    city: "Shenyang",
    country: "Liaoning, PR China",
    value: "SHE",
  },
  {
    city: "Shenzhen - Shenzhen Bao'an International",
    country: "Guangdong, PR China",
    value: "SZX",
  },
  {
    city: "Sheridan (WY)",
    country: "USA",
    value: "SHR",
  },
  {
    city: "Shreveport, La",
    country: "USA",
    value: "SHV",
  },
  {
    city: "Shute Harbour",
    country: "Australia",
    value: "JHQ",
  },
  {
    city: "Sibu",
    country: "Malaysia",
    value: "SBW",
  },
  {
    city: "Sidney (MT)",
    country: "USA",
    value: "SDY",
  },
  {
    city: "Silistra",
    country: "Bulgaria",
    value: "SLS",
  },
  {
    city: "Simferopol",
    country: "Ukraine",
    value: "SIP",
  },
  {
    city: "Sindhri",
    country: "Pakistan",
    value: "MPD",
  },
  {
    city: "Singapore - Changi",
    country: "Singapore",
    value: "SIN",
  },
  {
    city: "Singapore - Paya Lebar",
    country: "Singapore",
    value: "QPG",
  },
  {
    city: "Singapore - Seletar",
    country: "Singapore",
    value: "XSP",
  },
  {
    city: "Singleton",
    country: "Australia",
    value: "SIX",
  },
  {
    city: "Sioux city IA",
    country: "USA",
    value: "SUX",
  },
  {
    city: "Sioux Falls (SD)",
    country: "USA",
    value: "FSD",
  },
  {
    city: "Sishen",
    country: "South Africa",
    value: "SIS",
  },
  {
    city: "Sitka (AK)",
    country: "USA",
    value: "SIT",
  },
  {
    city: "Sivas",
    country: "Turkey",
    value: "VAS",
  },
  {
    city: "Siwa",
    country: "Egypt",
    value: "SEW",
  },
  {
    city: "Skagway (AK)",
    country: "USA",
    value: "SGY",
  },
  {
    city: "Skardu",
    country: "Pakistan",
    value: "KDU",
  },
  {
    city: "Skiathos",
    country: "Greece",
    value: "JSI",
  },
  {
    city: "Skopje",
    country: "Macedonia",
    value: "SKP",
  },
  {
    city: "Skrydstrup",
    country: "Denmark",
    value: "SKS",
  },
  {
    city: "Skukuza",
    country: "South Africa",
    value: "SZK",
  },
  {
    city: "Sligo",
    country: "Ireland",
    value: "SXL",
  },
  {
    city: "Smithers",
    country: "Canada",
    value: "YYD",
  },
  {
    city: "Sodankylae",
    country: "Finland",
    value: "SOT",
  },
  {
    city: "Soenderborg",
    country: "Denmark",
    value: "SGD",
  },
  {
    city: "Soendre Stroemfjord",
    country: "Greenland",
    value: "SFJ",
  },
  {
    city: "Sofia - Vrazhdebna",
    country: "Bulgaria",
    value: "SOF",
  },
  {
    city: "Sogndal",
    country: "Norway",
    value: "SOG",
  },
  {
    city: "Southampton - Eastleigh",
    country: "United Kingdom",
    value: "SOU",
  },
  {
    city: "South Bend (IN)",
    country: "USA",
    value: "SBN",
  },
  {
    city: "South Indian Lake, MB",
    country: "Canada",
    value: "XSI",
  },
  {
    city: "South Molle Island",
    country: "Australia",
    value: "SOI",
  },
  {
    city: "Southend (London)",
    country: "United Kingdom",
    value: "SEN",
  },
  {
    city: "Split",
    country: "Croatia (Hrvatska)",
    value: "SPU",
  },
  {
    city: "Spokane (WA)",
    country: "USA",
    value: "GEG",
  },
  {
    city: "Springbok",
    country: "South Africa",
    value: "SBU",
  },
  {
    city: "Springfield (IL)",
    country: "USA",
    value: "SPI",
  },
  {
    city: "Springfield (MO)",
    country: "USA",
    value: "SGF",
  },
  {
    city: "Srinagar",
    country: "India",
    value: "SXR",
  },
  {
    city: "St. Augustin, PQ",
    country: "Canada",
    value: "YIF",
  },
  {
    city: "St. Croix",
    country: "Virgin Islands (U.S.)",
    value: "STX",
  },
  {
    city: "St. Etienne",
    country: "France",
    value: "EBU",
  },
  {
    city: "St. George (UT)",
    country: "USA",
    value: "SGU",
  },
  {
    city: "St. John's",
    country: "Canada",
    value: "YYT",
  },
  {
    city: "St. Kitts",
    country: "St. Kitts and Nevis",
    value: "SKB",
  },
  {
    city: "St. Louis (MO) Lambert–St. Louis International Airport",
    country: "USA",
    value: "STL",
  },
  {
    city: "St. Lucia Hewanorra",
    country: "Saint Lucia",
    value: "UVF",
  },
  {
    city: "St. Lucia Vigle",
    country: "Saint Lucia",
    value: "SLU",
  },
  {
    city: "St. Marteen",
    country: "Netherlands Antilles",
    value: "SXM",
  },
  {
    city: "St. Martin",
    country: "St. Martin (Guadeloupe)",
    value: "SFG",
  },
  {
    city: "St. Petersburg (Leningrad) - Pulkovo",
    country: "Russia",
    value: "LED",
  },
  {
    city: "St. Pierre, NF",
    country: "Canada",
    value: "FSP",
  },
  {
    city: "St. Thomas",
    country: "Virgin Islands (U.S.)",
    value: "STT",
  },
  {
    city: "St. Vincent",
    country: "Saint Vincent and the Grenadines",
    value: "SVD",
  },
  {
    city: "Stansted (London)",
    country: "United Kingdom",
    value: "STN",
  },
  {
    city: "State College/Belefonte (PA)",
    country: "USA",
    value: "SCE",
  },
  {
    city: "Stavanger",
    country: "Norway",
    value: "SVG",
  },
  {
    city: "Steamboat Springs (CO)",
    country: "USA",
    value: "HDN",
  },
  {
    city: "Stettin",
    country: "Poland",
    value: "SZZ",
  },
  {
    city: "Stockholm Metropolitan Area",
    country: "Sweden",
    value: "STO",
  },
  {
    city: "Stockholm - Arlanda",
    country: "Sweden",
    value: "ARN",
  },
  {
    city: "Stockholm - Bromma",
    country: "Sweden",
    value: "BMA",
  },
  {
    city: "Stockton (CA)",
    country: "USA",
    value: "SCK",
  },
  {
    city: "Stornway",
    country: "United Kingdom",
    value: "SYY",
  },
  {
    city: "Strasbourg - Strasbourg Airport",
    country: "France",
    value: "SXB",
  },
  {
    city: "Streaky Bay",
    country: "Australia",
    value: "KBY",
  },
  {
    city: "Stuttgart - Echterdingen",
    country: "Germany",
    value: "STR",
  },
  {
    city: "Sui",
    country: "Pakistan",
    value: "SUL",
  },
  {
    city: "Sukkur",
    country: "Pakistan",
    value: "SKZ",
  },
  {
    city: "Sumburgh (Shetland)",
    country: "United Kingdom",
    value: "LSI",
  },
  {
    city: "Sun Valley (ID)",
    country: "USA",
    value: "SUN",
  },
  {
    city: "Sundsvall",
    country: "Sweden",
    value: "SDL",
  },
  {
    city: "Sunshine Coast",
    country: "Australia",
    value: "MCY",
  },
  {
    city: "Surabaya - Juanda",
    country: "Indonesia",
    value: "SUB",
  },
  {
    city: "Surat",
    country: "India",
    value: "STV",
  },
  {
    city: "Suva - Nausori Airport (Luvuluvu)",
    country: "Fiji",
    value: "SUV",
  },
  {
    city: "Swakopmund",
    country: "Namibia",
    value: "SWP",
  },
  {
    city: "Sydney - Sydney Airport",
    country: "Australia",
    value: "SYD",
  },
  {
    city: "Sylhet",
    country: "Bangladesh",
    value: "ZYL",
  },
  {
    city: "Syracuse (NY)",
    country: "USA",
    value: "SYR",
  },
  {
    city: "Tabuk",
    country: "Saudi Arabia",
    value: "TUU",
  },
  {
    city: "Taif",
    country: "Saudi Arabia",
    value: "TIF",
  },
  {
    city: "Taipei - Chiang Kai Shek",
    country: "Taiwan",
    value: "TPE",
  },
  {
    city: "Taipei - Sung Shan",
    country: "Taiwan",
    value: "TAY",
  },
  {
    city: "Taiyuan",
    country: "Shanxi, PR China",
    value: "TYN",
  },
  {
    city: "Takamatsu",
    country: "Japan",
    value: "TAK",
  },
  {
    city: "Talkeetna (AK)",
    country: "USA",
    value: "TKA",
  },
  {
    city: "Tallahassee (FL)",
    country: "USA",
    value: "TLH",
  },
  {
    city: "Tallinn - Pirita Harbour",
    country: "Estonia",
    value: "QUF",
  },
  {
    city: "Tallinn - Ulemiste",
    country: "Estonia",
    value: "TLL",
  },
  {
    city: "Tampa - International (FL)",
    country: "USA",
    value: "TPA",
  },
  {
    city: "Tampere",
    country: "Finland",
    value: "TMP",
  },
  {
    city: "Tampico - Gen. F. Javier Mina",
    country: "Mexico",
    value: "TAM",
  },
  {
    city: "Tamworth",
    country: "Australia",
    value: "TMW",
  },
  {
    city: "Tangier - Boukhalef",
    country: "Morocco",
    value: "TNG",
  },
  {
    city: "Taree",
    country: "Australia",
    value: "TRO",
  },
  {
    city: "Targovishte",
    country: "Bulgaria",
    value: "TGV",
  },
  {
    city: "Tashkent - International",
    country: "Uzbekistan",
    value: "TAS",
  },
  {
    city: "Tawau",
    country: "Malaysia",
    value: "TWU",
  },
  {
    city: "Tbilisi - Novo Alexeyevka",
    country: "Georgia",
    value: "TBS",
  },
  {
    city: "Te Anau",
    country: "New Zealand",
    value: "TEU",
  },
  {
    city: "Teesside, Durham Tees Valley",
    country: "United Kingdom",
    value: "MME",
  },
  {
    city: "Tegucigalpa",
    country: "Honduras",
    value: "TGU",
  },
  {
    city: "Tehran (Teheran) - Mehrabad",
    country: "Iran",
    value: "THR",
  },
  {
    city: "Tekirdag - Corlu",
    country: "Turkey",
    value: "TEQ",
  },
  {
    city: "Tel Aviv - Ben Gurion International",
    country: "Israel",
    value: "TLV",
  },
  {
    city: "Telluride (CO)",
    country: "USA",
    value: "TEX",
  },
  {
    city: "Temora",
    country: "Australia",
    value: "TEM",
  },
  {
    city: "Tenerife",
    country: "Spain",
    value: "TCI",
  },
  {
    city: "Tenerife - Sur Reina Sofia",
    country: "Spain",
    value: "TFS",
  },
  {
    city: "Tenerife - Norte Los Rodeos",
    country: "Spain",
    value: "TFN",
  },
  {
    city: "Tennant Creek",
    country: "Australia",
    value: "TCA",
  },
  {
    city: "Terceira",
    country: "Portugal",
    value: "TER",
  },
  {
    city: "Teresina",
    country: "Brazil",
    value: "THE",
  },
  {
    city: "Termez (Termes)",
    country: "Uzbekistan",
    value: "TMZ",
  },
  {
    city: "Terrace",
    country: "Canada",
    value: "YXT",
  },
  {
    city: "Terre Haute (IN)",
    country: "USA",
    value: "HUF",
  },
  {
    city: "Texarkana (AR)",
    country: "USA",
    value: "TXK",
  },
  {
    city: "Thaba'Nchu",
    country: "South Africa",
    value: "TCU",
  },
  {
    city: "The Pas",
    country: "Canada",
    value: "YQD",
  },
  {
    city: "Thessaloniki - Makedonia Apt.",
    country: "Greece",
    value: "SKG",
  },
  {
    city: "Thief River Falls (MN)",
    country: "USA",
    value: "TVF",
  },
  {
    city: "Thira",
    country: "Greece",
    value: "JTR",
  },
  {
    city: "Thiruvananthapuram",
    country: "India",
    value: "TRV",
  },
  {
    city: "Thisted",
    country: "Denmark",
    value: "TED",
  },
  {
    city: "Thompson",
    country: "Canada",
    value: "YTH",
  },
  {
    city: "Thorne Bay (AK)",
    country: "USA",
    value: "KTB",
  },
  {
    city: "Thunder Bay",
    country: "Canada",
    value: "YQT",
  },
  {
    city: "Thursday Island",
    country: "Australia",
    value: "TIS",
  },
  {
    city: "Tianjin",
    country: "China",
    value: "TSN",
  },
  {
    city: "Tijuana - Rodriguez",
    country: "Mexico",
    value: "TIJ",
  },
  {
    city: "Tioman",
    country: "Indonesia",
    value: "TOD",
  },
  {
    city: "Tirana - Rinas",
    country: "Albania",
    value: "TIA",
  },
  {
    city: "Tiruchirapally",
    country: "India",
    value: "TRZ",
  },
  {
    city: "Tivat",
    country: "Montenegro",
    value: "TIV",
  },
  {
    city: "Tobago",
    country: "Trinidad and Tobago",
    value: "TAB",
  },
  {
    city: "Tokushima",
    country: "Japan",
    value: "TKS",
  },
  {
    city: "Tokyo",
    country: "Japan",
    value: "TYO",
  },
  {
    city: "Tokyo - Haneda",
    country: "Japan",
    value: "HND",
  },
  {
    city: "Tokyo - Narita",
    country: "Japan",
    value: "NRT",
  },
  {
    city: "Toledo (OH)",
    country: "USA",
    value: "TOL",
  },
  {
    city: "Tom Price",
    country: "Australia",
    value: "TPR",
  },
  {
    city: "Toowoomba",
    country: "Australia",
    value: "TWB",
  },
  {
    city: "Toronto - Billy Bishop Toronto city Airport",
    country: "Canada",
    value: "YTZ",
  },
  {
    city: "Toronto - Toronto Pearson International Airport",
    country: "Canada",
    value: "YYZ",
  },
  {
    city: "Toronto",
    country: "Canada",
    value: "YTO",
  },
  {
    city: "Tortola",
    country: "British Virgin Islands",
    value: "TOV",
  },
  {
    city: "Touho",
    country: "New Caledonia",
    value: "TOU",
  },
  {
    city: "Toulouse - Blagnac Airport",
    country: "France",
    value: "TLS",
  },
  {
    city: "Townsville",
    country: "Australia",
    value: "TSV",
  },
  {
    city: "Toyama",
    country: "Japan",
    value: "TOY",
  },
  {
    city: "Trabzon",
    country: "Turkey",
    value: "TZX",
  },
  {
    city: "Trapani",
    country: "Italy",
    value: "TPS",
  },
  {
    city: "Traverse city (MI)",
    country: "USA",
    value: "TVC",
  },
  {
    city: "Treasure Cay",
    country: "Bahamas",
    value: "TCB",
  },
  {
    city: "Trenton/Princeton (NJ)",
    country: "USA",
    value: "TTN",
  },
  {
    city: "Treviso",
    country: "Italy",
    value: "TSF",
  },
  {
    city: "Tri-Cities Regional (TN) /VA",
    country: "USA",
    value: "TRI",
  },
  {
    city: "Trieste",
    country: "Italy",
    value: "TRS",
  },
  {
    city: "Tripoli - Tripoli International",
    country: "Libya",
    value: "TIP",
  },
  {
    city: "Tromsoe",
    country: "Norway",
    value: "TOS",
  },
  {
    city: "Trondheim",
    country: "Norway",
    value: "TRD",
  },
  {
    city: "Tsumeb",
    country: "Namibia",
    value: "TSB",
  },
  {
    city: "Tucson (AZ)",
    country: "USA",
    value: "TUS",
  },
  {
    city: "Tulepo (MS)",
    country: "USA",
    value: "TUP",
  },
  {
    city: "Tulsa (OK)",
    country: "USA",
    value: "TUL",
  },
  {
    city: "Tunis - Carthage",
    country: "Tunisia",
    value: "TUN",
  },
  {
    city: "Turbat",
    country: "Pakistan",
    value: "TUK",
  },
  {
    city: "Turin",
    country: "Italy",
    value: "TRN",
  },
  {
    city: "Turku",
    country: "Finland",
    value: "TKU",
  },
  {
    city: "Tuscaloosa (AL)",
    country: "USA",
    value: "TCL",
  },
  {
    city: "Tuxtla Gutierrez",
    country: "Mexico",
    value: "TGZ",
  },
  {
    city: "Twin Falls (ID)",
    country: "USA",
    value: "TWF",
  },
  {
    city: "Tyler (TX)",
    country: "USA",
    value: "TYR",
  },
  {
    city: "Ua Huka",
    country: "French Polynesia",
    value: "UAH",
  },
  {
    city: "Ua Pou",
    country: "French Polynesia",
    value: "UAP",
  },
  {
    city: "Ube",
    country: "Japan",
    value: "UBJ",
  },
  {
    city: "Uberaba",
    country: "Brazil",
    value: "UBA",
  },
  {
    city: "Uberlandia - Eduardo Gomes Airport",
    country: "Brazil",
    value: "UDI",
  },
  {
    city: "Ubon Ratchathani - Muang Ubon Airport",
    country: "Thailand",
    value: "UBP",
  },
  {
    city: "Udaipur - Dabok Airport",
    country: "India",
    value: "UDR",
  },
  {
    city: "Uden - Volkel Airport",
    country: "Netherlands",
    value: "UDE",
  },
  {
    city: "Udon Thani",
    country: "Thailand",
    value: "UTH",
  },
  {
    city: "Ufa",
    country: "Russia",
    value: "UFA",
  },
  {
    city: "Uherske Hradiste",
    country: "Czech Republic",
    value: "UHE",
  },
  {
    city: "Uige",
    country: "Angola",
    value: "UGO",
  },
  {
    city: "Ujung Pandang - Hasanudin Airport",
    country: "Indonesia",
    value: "UPG",
  },
  {
    city: "Ukhta",
    country: "Russia",
    value: "UCT",
  },
  {
    city: "Ukiah (CA)",
    country: "USA",
    value: "UKI",
  },
  {
    city: "Ulaanbaatar - Buyant Uhaa Airport",
    country: "Mongolia",
    value: "ULN",
  },
  {
    city: "Ulan-Ude",
    country: "Russia",
    value: "UUD",
  },
  {
    city: "Ulanhot",
    country: "PR China",
    value: "HLH",
  },
  {
    city: "Ulei",
    country: "Vanuatu",
    value: "ULB",
  },
  {
    city: "Ulsan",
    country: "South Korea",
    value: "USN",
  },
  {
    city: "Ulundi",
    country: "South Africa",
    value: "ULD",
  },
  {
    city: "Umea",
    country: "Sweden",
    value: "UME",
  },
  {
    city: "Umiujaq",
    country: "Canada",
    value: "YUD",
  },
  {
    city: "Umtata",
    country: "South Africa",
    value: "UTT",
  },
  {
    city: "Unalakleet (AK)",
    country: "USA",
    value: "UNK",
  },
  {
    city: "Union Island",
    country: "Saint Vincent and the Grenadines",
    value: "UNI",
  },
  {
    city: "Unst (Shetland Island) - Baltasound Airport",
    country: "United Kingdom",
    value: "UNT",
  },
  {
    city: "Upala",
    country: "Costa Rica",
    value: "UPL",
  },
  {
    city: "Upernavik - Upernavik Heliport",
    country: "Greenland",
    value: "JUV",
  },
  {
    city: "Upington",
    country: "South Africa",
    value: "UTN",
  },
  {
    city: "Upolu Point (HI)",
    country: "USA",
    value: "UPP",
  },
  {
    city: "Uranium city",
    country: "Canada",
    value: "YBE",
  },
  {
    city: "Urgench",
    country: "Uzbekistan",
    value: "UGC",
  },
  {
    city: "Uriman",
    country: "Venezuela",
    value: "URM",
  },
  {
    city: "Urmiehm (Orumieh)",
    country: "Iran",
    value: "OMH",
  },
  {
    city: "Uruapan",
    country: "Mexico",
    value: "UPN",
  },
  {
    city: "Urubupunga - Ernesto Pochler Airport",
    country: "Brazil",
    value: "URB",
  },
  {
    city: "Uruguaiana - Ruben Berta Airport",
    country: "Brazil",
    value: "URG",
  },
  {
    city: "Urumqi",
    country: "Xinjiang, PR China",
    value: "URC",
  },
  {
    city: "Uruzgan",
    country: "Afghanistan",
    value: "URZ",
  },
  {
    city: "Ushuaia - Islas Malvinas Airport",
    country: "Argentina",
    value: "USH",
  },
  {
    city: "Utapao (Pattaya)",
    country: "Thailand",
    value: "UTP",
  },
  {
    city: "Utica (NY) - Oneida County Airport",
    country: "USA",
    value: "UCA",
  },
  {
    city: "Utila",
    country: "Honduras",
    value: "UII",
  },
  {
    city: "Uummannaq",
    country: "Greenland",
    value: "UMD",
  },
  {
    city: "Uzhgorod",
    country: "Ukraine",
    value: "UDJ",
  },
  {
    city: "Vaasa",
    country: "Finland",
    value: "VAA",
  },
  {
    city: "Vaexjoe",
    country: "Sweden",
    value: "VXO",
  },
  {
    city: "Vail (CO)",
    country: "USA",
    value: "EGE",
  },
  {
    city: "Val d'Or",
    country: "Canada",
    value: "YVO",
  },
  {
    city: "Valdez (AK)",
    country: "USA",
    value: "VDZ",
  },
  {
    city: "Valdosta (GA)",
    country: "USA",
    value: "VLD",
  },
  {
    city: "Valencia",
    country: "Spain",
    value: "VLC",
  },
  {
    city: "Valencia",
    country: "Venezuela",
    value: "VLN",
  },
  {
    city: "Valladolid",
    country: "Spain",
    value: "VLL",
  },
  {
    city: "Valparaiso",
    country: "Chile",
    value: "VAP",
  },
  {
    city: "Valverde",
    country: "Spain",
    value: "VDE",
  },
  {
    city: "Van - Ferit Melen",
    country: "Turkey",
    value: "VAN",
  },
  {
    city: "Vancouver - Vancouver International",
    country: "Canada",
    value: "YVR",
  },
  {
    city: "Varadero",
    country: "Cuba",
    value: "VRA",
  },
  {
    city: "Varanasi",
    country: "India",
    value: "VNS",
  },
  {
    city: "Varkaus",
    country: "Finland",
    value: "VRK",
  },
  {
    city: "Varna",
    country: "Bulgaria",
    value: "VAR",
  },
  {
    city: "Vasteras",
    country: "Sweden",
    value: "VST",
  },
  {
    city: "Velikiye Luki (Welikije Luki)",
    country: "Russia",
    value: "VLU",
  },
  {
    city: "Venice - Marco Polo",
    country: "Italy",
    value: "VCE",
  },
  {
    city: "Veracruz",
    country: "Mexico",
    value: "VER",
  },
  {
    city: "Vernal (UT)",
    country: "USA",
    value: "VEL",
  },
  {
    city: "Vero Beach/Ft. Pierce (FL)",
    country: "USA",
    value: "VRB",
  },
  {
    city: "Verona (Brescia) Montichiari",
    country: "Italy",
    value: "VBS",
  },
  {
    city: "Verona",
    country: "Italy",
    value: "VRN",
  },
  {
    city: "Victoria",
    country: "Canada",
    value: "YYJ",
  },
  {
    city: "Victoria Falls",
    country: "Zimbabwe",
    value: "VFA",
  },
  {
    city: "Vidin",
    country: "Bulgaria",
    value: "VID",
  },
  {
    city: "Vientiane - Wattay",
    country: "Lao PDR",
    value: "VTE",
  },
  {
    city: "Vigo",
    country: "Spain",
    value: "VGO",
  },
  {
    city: "Villahermosa",
    country: "Mexico",
    value: "VSA",
  },
  {
    city: "Vilnius",
    country: "Lithuania",
    value: "VNO",
  },
  {
    city: "Virgin Gorda",
    country: "Virgin Islands (British)",
    value: "VIJ",
  },
  {
    city: "Visalia (CA)",
    country: "USA",
    value: "VIS",
  },
  {
    city: "Visby",
    country: "Sweden",
    value: "VBY",
  },
  {
    city: "Vitoria",
    country: "Spain",
    value: "VIT",
  },
  {
    city: "Vitoria - Eurico de Aguiar Salles Airport",
    country: "Brazil",
    value: "VIX",
  },
  {
    city: "Vryheid",
    country: "South Africa",
    value: "VYD",
  },
  {
    city: "Wabush",
    country: "Canada",
    value: "YWK",
  },
  {
    city: "Waco (TX)",
    country: "USA",
    value: "ACT",
  },
  {
    city: "Wagga",
    country: "Australia",
    value: "WGA",
  },
  {
    city: "Walla Walla (WA)",
    country: "USA",
    value: "ALW",
  },
  {
    city: "Wallis",
    country: "Wallis and Futuna Islands",
    value: "WLS",
  },
  {
    city: "Walvis Bay",
    country: "South Africa",
    value: "WVB",
  },
  {
    city: "Warrnambool",
    country: "Australia",
    value: "WMB",
  },
  {
    city: "Warsaw - Frédéric Chopin",
    country: "Poland",
    value: "WAW",
  },
  {
    city: "Washington DC - Baltimore Washington International",
    country: "USA",
    value: "BWI",
  },
  {
    city: "Washington DC - Dulles International",
    country: "USA",
    value: "IAD",
  },
  {
    city: "Washington DC - Ronald Reagan National",
    country: "USA",
    value: "DCA",
  },
  {
    city: "Washington DC",
    country: "USA",
    value: "WAS",
  },
  {
    city: "Waterloo IA",
    country: "USA",
    value: "ALO",
  },
  {
    city: "Watertown (SD)",
    country: "USA",
    value: "ATY",
  },
  {
    city: "Wausau/Stevens Point (WI)",
    country: "USA",
    value: "CWA",
  },
  {
    city: "Weipa",
    country: "Australia",
    value: "WEI",
  },
  {
    city: "Welkom",
    country: "South Africa",
    value: "WEL",
  },
  {
    city: "Wellington",
    country: "New Zealand",
    value: "WLG",
  },
  {
    city: "Wenatchee (WA)",
    country: "USA",
    value: "EAT",
  },
  {
    city: "West Palm Beach (FL)",
    country: "USA",
    value: "PBI",
  },
  {
    city: "West Yellowstone (MT)",
    country: "USA",
    value: "WYS",
  },
  {
    city: "Westerland, Sylt Airport",
    country: "Germany",
    value: "GWT",
  },
  {
    city: "Whakatane",
    country: "New Zealand",
    value: "WHK",
  },
  {
    city: "Whale Cove, NT",
    country: "Canada",
    value: "YXN",
  },
  {
    city: "Whangarei",
    country: "New Zealand",
    value: "WRE",
  },
  {
    city: "White Plains (NY)",
    country: "USA",
    value: "HPN",
  },
  {
    city: "Whitehorse",
    country: "Canada",
    value: "YXY",
  },
  {
    city: "Whitsunday Resort",
    country: "Australia",
    value: "HAP",
  },
  {
    city: "Whyalla",
    country: "Australia",
    value: "WYA",
  },
  {
    city: "Wichita Falls (TX)",
    country: "USA",
    value: "SPS",
  },
  {
    city: "Wichita (KS)",
    country: "USA",
    value: "ICT",
  },
  {
    city: "Wick",
    country: "United Kingdom",
    value: "WIC",
  },
  {
    city: "Wickham",
    country: "Australia",
    value: "WHM",
  },
  {
    city: "Wien (Vienna) - Vienna International",
    country: "Austria",
    value: "VIE",
  },
  {
    city: "Wiesbaden, Air Base",
    country: "Germany",
    value: "WIE",
  },
  {
    city: "Wilkes Barre/Scranton (PA)",
    country: "USA",
    value: "AVP",
  },
  {
    city: "Williamsport (PA)",
    country: "USA",
    value: "IPT",
  },
  {
    city: "Williston (ND)",
    country: "USA",
    value: "ISL",
  },
  {
    city: "Wilmington (NC)",
    country: "USA",
    value: "ILM",
  },
  {
    city: "Wilna (Vilnius)",
    country: "Lithuania",
    value: "VNO",
  },
  {
    city: "Wiluna",
    country: "Australia",
    value: "WUN",
  },
  {
    city: "Windhoek - Eros",
    country: "Namibia",
    value: "ERS",
  },
  {
    city: "Windhoek - Hosea Kutako International",
    country: "Namibia",
    value: "WDH",
  },
  {
    city: "Windsor Ontario",
    country: "Canada",
    value: "YQG",
  },
  {
    city: "Winnipeg International",
    country: "Canada",
    value: "YWG",
  },
  {
    city: "Wolf Point (MT)",
    country: "USA",
    value: "OLF",
  },
  {
    city: "Wollongong",
    country: "Australia",
    value: "WOL",
  },
  {
    city: "Woomera",
    country: "Australia",
    value: "UMR",
  },
  {
    city: "Worcester (MA)",
    country: "USA",
    value: "ORH",
  },
  {
    city: "Worland (WY)",
    country: "USA",
    value: "WRL",
  },
  {
    city: "Wrangell (AK)",
    country: "USA",
    value: "WRG",
  },
  {
    city: "Wuhan",
    country: "Hubei, PR China",
    value: "WUH",
  },
  {
    city: "Wyndham",
    country: "Australia",
    value: "WYN",
  },
  {
    city: "Xiamen",
    country: "Fujian, PR China",
    value: "XMN",
  },
  {
    city: "Xi'an - Xianyang",
    country: "Shaanxi, PR China",
    value: "XIY",
  },
  {
    city: "Yakima (WA)",
    country: "USA",
    value: "YKM",
  },
  {
    city: "Yakutat (AK)",
    country: "USA",
    value: "YAK",
  },
  {
    city: "Yakutsk",
    country: "Russia",
    value: "YKS",
  },
  {
    city: "Yamagata, Junmachi",
    country: "Japan",
    value: "GAJ",
  },
  {
    city: "Yamoussoukro",
    country: "Côte d'Ivoire",
    value: "ASK",
  },
  {
    city: "Yanbu",
    country: "Saudi Arabia",
    value: "YNB",
  },
  {
    city: "Yangon (Rangoon) - Mingaladon",
    country: "Myanmar",
    value: "RGN",
  },
  {
    city: "Yaounde",
    country: "Cameroon",
    value: "YAO",
  },
  {
    city: "Yellowknife",
    country: "Canada",
    value: "YZF",
  },
  {
    city: "Yekaterinburg - Koltsovo Airport",
    country: "Russia",
    value: "SVX",
  },
  {
    city: "Yichang",
    country: "Hubei, PR China",
    value: "YIH",
  },
  {
    city: "Yokohama",
    country: "Japan",
    value: "YOK",
  },
  {
    city: "Yuma (AZ)",
    country: "USA",
    value: "YUM",
  },
  {
    city: "Zacatecas",
    country: "Mexico",
    value: "ZCL",
  },
  {
    city: "Zadar",
    country: "Croatia (Hrvatska)",
    value: "ZAD",
  },
  {
    city: "Zagreb - Zagreb Airport Pleso",
    country: "Croatia (Hrvatska)",
    value: "ZAG",
  },
  {
    city: "Zakynthos",
    country: "Greece",
    value: "ZTH",
  },
  {
    city: "Zaragoza",
    country: "Spain",
    value: "ZAZ",
  },
  {
    city: "Zhob",
    country: "Pakistan",
    value: "PZH",
  },
  {
    city: "Zinder",
    country: "Niger",
    value: "ZND",
  },
  {
    city: "Zouerate",
    country: "Mauritania",
    value: "OUZ",
  },
  {
    city: "Zurich (Zürich) - Kloten",
    country: "Switzerland",
    value: "ZRH",
  },
];

export default cities;
